export const workspace = {
  codeLanguagesLabel: 'Code language',
  codeLanguages: {
    curl: 'curl',
    js: 'JavaScript',
    python: 'Python',
    powerQuery: 'Power Query',
    powershell: 'PowerShell',
  },
  overviewScreen: {
    loading: 'Loading workspace…',
    fallbackWorkspaceName: 'Workspace',
    fallbackTeamName: 'Team',
    fallbackPersonalName: 'Personal',
    notSet: 'Not set',
    roleUnavailable: 'Role unavailable',
    personalMode: 'Personal mode',
    addSummaryHint: 'Add a short summary in organization profile.',
    currentContextLabel: 'Current context',
    yourRoleLabel: 'Your role',
    currencyLabel: 'Currency',
    languageLabel: 'Language',
    manageOrgA11y: 'Manage organization profile',
    viewOrgA11y: 'View organization profile',
    manageOrgTitle: 'Manage organization',
    viewOrgTitle: 'View organization',
    manageOrgSubtitle: 'Profile, legal details, and company summary.',
    teamsA11y: 'Teams and invites',
    teamsTitle: 'Teams & invites',
    teamsSubtitle: 'Switch context, memberships, and invitations.',
    configurationTitle: 'Configuration',
    configurationSubtitle: 'Everything you can set up, grouped by area.',
    groupWorkspaceLabel: 'Workspace',
    groupOperationsLabel: 'Operations',
    groupTemplatesLabel: "Checklists",
    groupIntegrationsLabel: 'Integrations',
    groupAiLabel: 'AI',
    groupBillingLabel: 'Billing',
    groupSupportLabel: 'Support',
    itemOrgProfileTitle: 'Organization profile',
    itemOrgProfileSubtitleAdmin: 'Legal name, industry, address, and private notes.',
    itemOrgProfileSubtitleMember: 'View the legal name, industry, and address.',
    itemTeamsTitle: 'Teams & invites',
    itemTeamsSubtitleAdmin: 'Members, roles, context switching, and invitations.',
    itemTeamsSubtitleMember: 'View members and roles; switch context.',
    itemBrandingTitle: 'Report branding',
    itemBrandingSubtitleAdmin: 'Logo and company details for PDFs, shares, and exports only.',
    itemBrandingSubtitleMember: 'View the logo and company details used on PDFs, shares, and exports.',
    itemContractorWorkTitle: 'My work as a contractor',
    itemContractorWorkSubtitle: 'Jobs and quote requests other workspaces have sent you.',
    itemMaintenancePlansTitle: "Maintenance plans",
    itemMaintenancePlansSubtitle: "Every repeating plan in the workspace, grouped by asset.",
    itemFeaturesTitle: "Features",
    itemFeaturesSubtitle: "What is enabled, locked by plan, or turned off.",
    itemDefaultsTitle: 'Regional defaults',
    itemDefaultsSubtitle: 'Currency, language, timezone, and share methods.',
    itemTemplatesTitle: "Checklists",
    itemTemplatesSubtitle: 'Reusable inspection checklists.',
    itemIndustryPacksTitle: 'Industry packs',
    itemIndustryPacksSubtitle: 'Starting points for property, fleet, equipment and facilities.',
    itemIntegrationsTitle: 'Integrations & API',
    itemIntegrationsSubtitle: 'Imports, public API, MCP, automations, and connected assets.',
    itemAiAuditTitle: 'AI & automation audit',
    itemAiAuditSubtitle: 'Workspace AI usage and automation activity.',
    itemBillingTitle: 'Billing & usage',
    itemBillingSubtitleAdmin: 'Plan, AI credits, billable assets, and credit ledger.',
    itemBillingSubtitleMember: 'View the plan and credit usage; only an admin can change them.',
    itemHandbookTitle: 'Integration handbook',
    itemHandbookSubtitle: 'Guides for connecting and automating AssetWRX.',
  },
  organizationScreen: {
    allSaved: "Saved. Your workspace details are up to date.",
    allChangesSaved: "All changes saved",
    saveChanges: "Save changes",
    unsavedKeep: "Keep editing",
    unsavedDiscard: "Leave",
    unsavedBody: "You changed details on this page. If you leave now, those changes are lost.",
    unsavedTitle: "Leave without saving?",
    pageTitle: 'Organization profile',
    pageSubtitle:
      'Workspace identity, contact details, and legal information. Report-specific header styling lives under Reports.',
    memberNotice:
      'Only workspace owners can edit organization details and report branding. You can view shared information below.',
    loadingProfile: 'Loading organization profile…',
    fallbackWorkspaceName: 'Workspace',
    logoSectionTitle: 'Workspace logo',
    changeLogoA11y: 'Change workspace logo',
    uploading: 'Uploading…',
    changeLogo: 'Change logo',
    removeLogoA11y: 'Remove logo',
    remove: 'Remove',
    workspaceNameLabel: 'Workspace name',
    workspaceNamePlaceholder: 'Workspace label',
    saveWorkspaceName: 'Save workspace name',
    organizationSectionTitle: 'Organization',
    summaryLabel: 'Summary',
    summaryPlaceholder: 'Short description of your organization',
    industryLabel: 'Industry',
    companySizeLabel: 'Company size',
    companySizePlaceholder: 'e.g. 1–10, 11–50',
    websiteLabel: 'Website',
    websitePlaceholder: 'https://example.com',
    countryCodeLabel: 'Country code',
    countryCodePlaceholder: 'e.g. GB',
    regionLabel: 'Region',
    saveOrganization: 'Save organization',
    supportContactsTitle: 'Support contacts',
    supportEmailLabel: 'Support email',
    supportPhoneLabel: 'Support phone',
    saveSupportContacts: 'Save support contacts',
    legalBillingTitle: 'Legal & billing',
    legalBillingSubtitle: 'Visible only to workspace owners.',
    legalEntityNameLabel: 'Legal entity name',
    tradingNameLabel: 'Trading / display name',
    primaryContactEmailLabel: 'Primary contact email',
    primaryContactPhoneLabel: 'Primary contact phone',
    registeredAddressLabel: 'Registered address',
    operationalAddressLabel: 'Operational address',
    taxNumberLabel: 'Tax / VAT number',
    registrationNumberLabel: 'Company registration number',
    billingContactNameLabel: 'Billing contact name',
    billingContactEmailLabel: 'Billing contact email',
    billingContactPhoneLabel: 'Billing contact phone',
    saveLegalBilling: 'Save legal & billing',
    memberPrivateNote: 'Legal entity, tax, registration, and billing details are restricted to workspace owners.',
    reportBrandingLink: 'Report branding & exports',
    savedTitle: 'Saved',
    workspaceNameSaved: 'Workspace name updated.',
    saveFailedTitle: 'Save failed',
    couldNotSave: 'Could not save.',
    checkPhoneTitle: 'Check the phone number',
    checkPhoneBody: 'Enter a valid number for the selected country, or leave the phone empty.',
    organizationDetailsSaved: 'Organization details updated.',
    legalBillingSaved: 'Legal and billing details updated.',
    permissionRequiredTitle: 'Permission required',
    permissionRequiredBody: 'Please allow photo library access to upload a logo.',
    fileTooLargeTitle: 'File too large',
    fileTooLargeBody: 'Logo must be 10MB or smaller.',
    logoUpdated: 'Workspace logo updated.',
    uploadFailedTitle: 'Upload failed',
    couldNotUploadLogo: 'Could not upload logo.',
    removedTitle: 'Removed',
    logoRemoved: 'Workspace logo removed.',
    removeFailedTitle: 'Remove failed',
    couldNotRemoveLogo: 'Could not remove logo.',
  },
  brandingScreen: {
    readOnlyTitle: 'Read-only',
    readOnlyBody: 'Only workspace owners can change report branding.',
    permissionRequiredTitle: 'Permission required',
    permissionRequiredBody: 'Please allow photo library access to upload a logo.',
    fallbackWorkspaceName: 'Workspace',
    workspaceBrandingAppliedTitle: 'Workspace branding applied',
    workspaceBrandingAppliedBody:
      'Workspace name and logo were copied into the report-branding fields. Review and Save to apply.',
    noWorkspaceTitle: 'No workspace',
    noWorkspaceBody: 'Your profile does not have a workspace account yet.',
    savedTitle: 'Saved',
    brandingSaved: 'Report branding settings updated.',
    saveFailedTitle: 'Save failed',
    couldNotSaveBranding: 'Could not save report branding settings.',
    intro:
      'Applied to hosted reports, PDF exports, shared inspection outputs, and share emails. Set fields here to replace default AssetWRX branding on those outputs; leave them blank to keep AssetWRX defaults.',
    memberHint: 'Only workspace owners can edit branding. You can review the current settings below.',
    fromReportHint:
      'This section was opened from the reporting workspace. Changes apply immediately to hosted reports and new exports.',
    loadingSettings: 'Loading branding settings…',
    reportLogoLabel: 'Report logo',
    reportLogoHint: 'Used on reports, PDF exports, and share emails only.',
    changeLogoA11y: 'Change report logo image',
    addLogoA11y: 'Add report logo image',
    changeLogo: 'Change report logo',
    addLogo: 'Add report logo',
    removeLogoA11y: 'Remove report logo',
    removeLogo: 'Remove report logo',
    copyFromWorkspaceA11y: 'Use your workspace logo and name for reports',
    copyFromWorkspace: 'Use my workspace logo & name',
    noLogoHint: 'No report logo set — exports use AssetWRX branding until you add one here.',
    companyNameLabel: 'Company / display name',
    companyNamePlaceholder: 'e.g. Northfield Property Services',
    companyNameA11y: 'Company or display name for reports',
    addressBlockLabel: 'Address block',
    addressBlockPlaceholder: 'Address lines shown on report header',
    addressBlockA11y: 'Report address block',
    contactBlockLabel: 'Contact block',
    contactBlockPlaceholder: 'Email / phone / website',
    contactBlockA11y: 'Report contact block',
    footerLabel: 'Footer / disclaimer',
    footerPlaceholder: 'Optional report footer disclaimer',
    footerA11y: 'Report footer or disclaimer',
    accentColorLabel: 'Accent color (optional)',
    accentColorA11y: 'Report accent color hex value',
    accentColorHint: 'Use hex format (#RRGGBB). Leave blank to use the default AssetWRX accent.',
    savingA11y: 'Saving report branding',
    saveA11y: 'Save report branding settings',
    saving: 'Saving…',
    saveBranding: 'Save branding',
  },
  teamsScreen: {
    recentlyJoined: 'Recently joined',
    switchFailedTitle: 'Could not switch workspace',
    tryAgain: 'Please try again.',
    pendingInviteTitle: 'Pending team invitation',
    pendingInviteBody_one: '{{count}} invite waiting in team management.',
    pendingInviteBody_other: '{{count}} invites waiting in team management.',
    teamManagementTitle: 'Team management',
    teamManagementSubtitle: 'Invites, roles, and advanced options.',
    createFirstTeam: 'Create your first team',
    openTeamManagement: 'Open team management',
    teamManagementMenuSubtitle: 'Full-screen settings for your teams and invites.',
    teamsAndContextTitle: 'Your teams',
    teamsAndContextSubtitle: 'The team you are working in, and every team you belong to.',
    changeContext: 'Switch team',
    workspaceLabel: 'Workspace',
    currentContextLabel: 'Working in',
    roleInContextLabel: 'Your role',
    loadFailed: "We couldn't load your teams. Reopen this page to try again.",
    teamMembershipsTitle: 'Team memberships',
    manageInTeamSettings: 'Manage in team settings',
    noMemberships: 'You are not currently a member of any team.',
    membershipMeta: 'Role: {{role}} · Joined {{date}}',
    currentBadge: 'Current',
    workingContextTitle: 'Switch team',
    workingContextSubtitle: "Pick which team's assets and work you see. Personal shows only your own.",
    personalOption: 'Personal',
  },
  aiUsageInsights: {
    title: 'AI usage insights',
    subtitle: 'Rolls up calls, credits, and feedback from the last {{days}} days. Updates on refresh.',
    refresh: 'Refresh',
    loadingUsage: 'Loading usage…',
    alertHeader_one: '{{count}} capability needs review',
    alertHeader_other: '{{count}} capabilities need review',
    healthAttention: 'Some AI features need attention — a workspace admin can review the details.',
    healthNormal: 'All AI features are running normally.',
    kpiCreditsBurned: 'Credits burned',
    kpiCalls: 'Calls',
    kpiErrors: 'Errors',
    kpiCacheHitRate: 'Cache hit rate',
    projectedMonthly: 'Projected monthly',
    pctOfBudget: '{{pct}}% of {{budget}} budget',
    extrapolatedFromWindow: 'Linearly extrapolated from this {{days}}d window',
    noActivity: 'No AI activity in this window. Encourage users to try the copilot to see signal here.',
    colCapability: 'Capability',
    colCalls: 'Calls',
    colCredits: 'Credits',
    colAvgMs: 'Avg ms',
    colFeedback: '👍 / 👎',
    colAccept: 'Accept',
    openDetailHint: 'Open capability detail',
    // lib/ai/deriveCapabilityHealthAlerts.ts
    alert: {
      neverHelpful_one: '{{count}} negative vote and no positive ones. Strong signal something is off.',
      neverHelpful_other: '{{count}} negative votes and no positive ones. Strong signal something is off.',
      lowAcceptance: 'Acceptance is {{pct}}% (n={{total}}). Review prompt or examples.',
      highErrorRate: '{{pct}}% of calls erroring ({{errors}}/{{calls}}). Check the edge function or model availability.',
    },
    // lib/ai/usageFeatureLabel.ts: usage keys as people read them; an unlisted key shows as written.
    feature: {
      unknown: 'Unattributed',
      ai_assistant: 'AI assistant',
      connected_event: 'Connected device event',
      automation: {
        asset_health_calculated: 'Asset health calculated',
        asset_compliance_calculated: 'Asset compliance calculated',
        asset_risk_calculated: 'Asset risk calculated',
        asset_risk_assessment_persist_batch: 'Asset risk saved in bulk',
        recipe_run: 'Automation recipe run',
      },
      asset: {
        extract_vin_or_serial: 'Read VIN or serial number',
        generate_advanced_report: 'Advanced asset report',
        improve_description: 'Improve asset description',
        infer_identity: 'Identify the asset',
        journey_summary: 'Asset journey summary',
        timeline_summary: 'Asset timeline summary',
      },
      assistant: {
        recommend_next_actions: 'Assistant next actions',
      },
      connected: {
        event_ingest: 'Connected device message',
      },
      document: {
        extract_metadata: 'Read document details',
      },
      esg: {
        writeup: 'ESG write-up',
      },
      home: {
        operations_briefing: 'Operations briefing',
      },
      insights: {
        recommend_next_actions: 'Recommended next actions',
      },
      inspection: {
        analyse_image: 'Analyse inspection photo',
        completed: 'Inspection completed',
        fix_recommendation: 'Fix recommendation',
        generate_job_drafts: 'Draft jobs from an inspection',
        generate_summary: 'Inspection summary',
        improve_note: 'Improve inspection note',
      },
      job: {
        completion_closeout: 'Job close-out',
        extract_invoice_line_items: 'Read invoice line items',
        generate_invoice_draft: 'Draft invoice',
        improve_update_note: 'Improve job update',
        suggest_certificate_draft: 'Suggest certificate',
        suggest_completion_criteria: 'Suggest completion criteria',
        suggest_follow_up_job: 'Suggest follow-up job',
      },
      quote: {
        compare_quotes: 'Compare quotes',
        generate_rfq_scope: 'Draft quote request scope',
        recommend_quote: 'Recommend a quote',
        summarize_quotes: 'Summarise quotes',
      },
      request: {
        polish_follow_up_draft: 'Polish request reply',
      },
      site: {
        generate_advanced_report: 'Advanced site report',
      },
      template: {
        generate_draft: 'Draft checklist',
      },
      vision: {
        analyse_group: 'WRX Vision scan',
        verify_completion: 'WRX Verified evidence check',
      },
      work: {
        analyse_evidence: 'Analyse work evidence',
      },
    },
    entityType: {
      asset: 'Asset',
      job: 'Job',
      inspection: 'Inspection',
      request: 'Request',
      quote: 'Quote',
      site: 'Site',
      document: 'Document',
      template: 'Checklist',
      contact: 'Contact',
    },
    feedback: {
      helpful: 'Helpful',
      not_helpful: 'Not helpful',
    },
    action: {
      refine: 'Asked to refine',
    },
    creditMode: {
      none: 'none',
      estimated: 'estimated',
      actual: 'actual',
    },
  },
  aiCapabilityDetail: {
    kicker: 'Capability detail · 30d',
    closeA11y: 'Close detail',
    loading: 'Loading detail…',
    noFeedback: 'No feedback yet for this capability.',
    sectionFeedback: 'Feedback breakdown',
    sectionActionTaken: 'Action taken',
    sectionDailyActivity: 'Daily activity',
    noActivity: 'No activity in this window.',
    sectionRecentEntities: 'Recent entities',
    totalLine_one: '{{count}} total event in window.',
    totalLine_other: '{{count}} total events in window.',
  },
  syncCenter: {
    errors: {
      unsupportedWrite: "This change needs a newer version of the app to send. It stays saved on this device.",
      waitingOnFailedParent: "Waiting for the record it belongs to, which could not be sent. Fix or discard that item on this page first.",
      transientUnknown: "This change has not been sent yet. It will be tried again; contact support if this keeps happening.",
      permanentUnknown: "This change cannot be applied automatically. Review it or discard it.",
      serverError: "The server had a problem. It will be sent again; contact support if this keeps happening.",
      rateLimited: "The server is busy. It will be sent again shortly.",
      network: "Network problem. It will be sent automatically, or you can retry now.",
      conflict: "A newer version is already saved. Discard this change, then check the latest one.",
      notFound: "What this change was for has been removed. You can discard it.",
      permission: "You don't have permission to send this change. Ask a workspace admin.",
      blocked: "This change is saved on this device but could not be sent. Retry it, or discard it.",
      authRetry: "Sign in again to send this change. It is saved on this device.",
    },
    pageTitle: "Unsent changes",
    pageSubtitle: "Changes saved on this device that are waiting to be sent.",
    healthTitle: 'Health',
    statusSectionTitle: 'Status',
    retryAll: "Send now",
    queuedWritesSynced: "Everything is sent",
    lastSync: "Last sent {{age}}",
    noSyncsYet: "Nothing sent yet",
    queuedLabel: "Waiting to send",
    inFlightLabel: "Sending now",
    lastFlushLabel: "Last sent",
    lastDurationLabel: 'Last duration',
    never: 'Never',
    pendingWritesTitle: "Waiting to send",
    unsentAnswersTitle: "Inspection answers on this device",
    unsentAnswersBody: "They are sent automatically when you're online. If the inspection was changed elsewhere, open it to review and send them.",
    openInspection: "Open inspection",
    queuedInspectionPhotos: "Inspection photos waiting to upload: {{total}}",
    recoveryNote_one: "One change saved by an earlier version of the app has no recorded owner. It was kept rather than given to whoever signed in next. If this work is yours, claim it and it will be sent; otherwise discard it.",
    recoveryNote_other: "{{count}} changes saved by an earlier version of the app have no recorded owner. They were kept rather than given to whoever signed in next. If this work is yours, claim them and they will be sent; otherwise discard them.",
    claimAsMine: 'Claim as mine',
    discard: 'Discard',
    claimAllAsMine: 'Claim all as mine',
    discardAll: 'Discard all',
    noQueuedWritesTitle: "Nothing waiting to send",
    noQueuedWritesBody: "Changes you make on this device are sent as soon as you are online. Inspection photos show on their inspection.",
    hideTechnicalDetails: 'Hide technical details',
    showTechnicalDetails: 'Show technical details',
    technicalDetail_one: '{{rawError}} · {{count}} attempt',
    technicalDetail_other: '{{rawError}} · {{count}} attempts',
    retry: 'Retry',
    offlineSupportTitle: "What works without a connection",
    statusOnlineRequired: "Needs a connection",
    statusLocalDraft: "Saved on this device first",
    policyEntity: {
      Asset: 'Asset',
      Inspection: 'Inspection',
      Job: 'Job',
      Schedule: 'Schedule',
      Request: 'Request',
      Comment: 'Comment',
      Media: 'Media',
    },
    policyAction: {
      createAsset: 'Create asset',
      editAsset: 'Edit asset',
      addDocument: 'Add document',
      answerChecklistItems: 'Answer checklist items',
      startInspection: 'Start a new inspection',
      submitInspection: 'Pause, continue or complete an inspection',
      createJob: 'Create job',
      addJobPhotos: 'Add photos when creating a job',
      postActivity: 'Post activity notes and photos',
      moveJobStatus: 'Accept, schedule or sign off a job',
      startPauseCompleteJob: "Start, pause or complete a job",
      updateJobDetails: 'Update job details',
      scheduleInspection: 'Schedule inspection',
      answerCheck: 'Answer a check',
      recordMeterReading: 'Record a meter reading',
      reportCantComplete: "Report you can't complete work",
      decideChangeRequest: 'Decide a change request',
      createOrRespondRequest: 'Create or respond',
      postComment: 'Post comment',
      uploadEvidence: 'Upload evidence',
    },
    supportCopy: {
      queued: 'Saved locally, then synced automatically',
      local_draft: 'Saved locally until submission',
      online_required: 'Online required',
    },
    conflictCopy: {
      idempotent_replay: 'Safe retry: the same operation is not duplicated.',
      merge_review: 'If the server changed, review and merge before saving.',
      latest_write: 'The latest accepted server write is authoritative.',
    },
    entryAsset: 'New asset',
    entryInspectionJob: 'Inspection job',
    entryJob: 'New job',
    entryJobPhoto: 'Job photo',
    entryJobUpdate: 'Job update',
    entryScheduledInspection: 'Scheduled inspection',
    entryAssetDocument: 'Asset document',
    entryFieldMove: "Start, pause or completion",
    entryNewInspection: 'New inspection',
    ageJustNow: 'just now',
    ageMinutesAgo: '{{mins}}m ago',
    ageHoursAgo: '{{hrs}}h ago',
    ageDaysAgo: '{{days}}d ago',
    readErrorBody: 'Saved work could not be read. It is still on this device and has not been discarded.',
    flushErrorBody: "We couldn't send your changes. They are still saved on this device.",
    claimErrorBody: 'Those changes could not be claimed. They are still saved on this device.',
    discardManyErrorBody: 'Those changes could not be discarded. They are still saved on this device.',
    discardOneErrorBody: 'The change could not be discarded. It is still saved on this device.',
  },
  trustCenter: {
    pageTitle: 'Trust Center',
    pageSubtitle: 'Audit, integrations, access, and compliance posture for this workspace.',
    loading: 'Loading...',
    auditLogTitle: 'Audit log',
    auditLogDescription: 'Who did what, when, across assets, jobs, inspections, and admin actions.',
    auditLogEmptyTitle: 'Audit log not yet available',
    auditLogEmptyBody:
      'Once the audit feed is enabled for your workspace, every meaningful action will appear here with actor, target, and timestamp.',
    integrationHealthTitle: 'Integration health',
    integrationHealthDescription: 'API + MCP + IoT connectors: connection state, last sync, error rate.',
    integrationHealthEmptyTitle: 'No integrations connected',
    integrationHealthEmptyBody:
      'Connect an integration to see live health here — including last successful sync, error rate, and retry status.',
    webhookRetryTitle: 'Webhook retries',
    webhookRetryDescription: 'Outbound webhook deliveries that failed and were retried, with bodies and response codes.',
    webhookRetryEmptyTitle: 'No webhook failures',
    webhookRetryEmptyBody: 'Failed webhook deliveries (with their retry history and bodies) will appear here when they occur.',
    apiKeysTitle: 'API keys & scopes',
    apiKeysDescription: 'Issued keys, scopes, rotation status, and who created them.',
    apiKeysEmptyTitle: 'No API keys issued',
    apiKeysEmptyBody: 'When a workspace owner creates an API key, its scopes and rotation cadence will live here.',
    rolesTitle: 'Roles & permissions',
    rolesDescription: 'Who can do what across teams, with effective permissions and overrides.',
    rolesEmptyTitle: 'No role assignments recorded yet',
    rolesEmptyBody: 'Each user and team, the permissions they hold, and any overrides will appear here.',
    complianceTitle: 'Compliance posture',
    complianceDescription: 'SOC2 / ISO readiness, data residency, retention, and export status.',
    complianceEmptyTitle: 'No compliance signals recorded yet',
    complianceEmptyBody:
      'SOC2 / ISO readiness, data residency, retention, and export status will appear here as they are recorded for this workspace.',
    // Audit log rows (lib/audit/auditFeed.ts holds the same English as the default).
    audit: {
      byActor: 'by {{name}}',
      toRecipient: 'to {{name}}',
      action: {
        asset: {
          created: 'Asset created',
          updated: 'Asset updated',
          shared: 'Asset shared',
          share_revoked: 'Asset share revoked',
        },
        inspection: {
          created: 'Inspection created',
          started: 'Inspection started',
          completed: 'Inspection completed',
          failed_item_recorded: 'Failed item recorded',
          approved: 'Inspection approved',
          reopened: 'Inspection re-opened',
          shared: 'Report shared',
          share_approved: 'Report approved',
          share_rejected: 'Report rejected',
        },
        job: {
          created: 'Job created',
          assigned: 'Job assigned',
          started: 'Job started',
          completed: 'Job completed',
          reopened: 'Job reopened',
          verified: 'Job verified',
        },
        document: {
          created: 'Document added',
          renewed: 'Document renewed',
          superseded: 'Document superseded',
        },
        compliance: {
          expiring_detected: 'Compliance expiry detected',
        },
        insight: {
          generated: 'Insight generated',
          feedback_submitted: 'Insight feedback submitted',
        },
        technician: {
          assignment_recommended: 'Assignee recommended',
          assignment_accepted: 'Assignee accepted',
        },
        condition: {
          assessment_calculated: 'Condition assessed',
          recommendation_created: 'Condition recommendation created',
          recommendation_accepted: 'Condition recommendation accepted',
          recommendation_dismissed: 'Condition recommendation dismissed',
        },
        scheduling: {
          recommendation_shown: 'Scheduling suggestion shown',
          recommendation_selected: 'Scheduling suggestion chosen',
        },
        assistant: {
          change: 'Changed via the assistant',
          undo: 'Undone via the assistant',
        },
      },
      entity: {
        asset: 'Asset',
        job: 'Job',
        inspection: 'Inspection',
        document: 'Document',
        asset_share: 'Asset share',
        inspection_share: 'Report share',
        insight: 'Insight',
        compliance: 'Compliance',
        technician: 'Assignment',
        site: 'Site',
        scheduled_inspection: 'Scheduled inspection',
        template: 'Checklist',
        asset_request: 'Request',
      },
    },
  },
  teamInvite: {
    pageTitle: 'Team invitation',
    invalidLink: 'Invalid invitation link',
    loadTimeout: 'The invitation is taking too long to load. Check your connection and try again.',
    notFound: 'Invitation not found',
    expiredMessage: 'Your invitation{{where}} expired{{when}}. Ask whoever invited you to send a new one.',
    expiredWhereSuffix: ' to {{teamName}}',
    expiredWhenSuffix: ' on {{date}}',
    loadFailed: 'Failed to load invitation',
    emailMismatchTitle: 'Email mismatch',
    emailMismatchBody: 'This invitation was sent to {{email}}. Please sign in with that email to accept.',
    errorTitle: 'Error',
    linkSendFailedTitle: 'Could not send the link',
    linkSendFailedBody: 'Please try again, or ask whoever invited you to resend the invitation.',
    loadingInvitation: 'Loading invitation…',
    invalidOrExpiredTitle: 'Invalid or expired',
    linkNoLongerValid: 'This invitation link is no longer valid.',
    tryAgain: 'Try again',
    goToApp: 'Go to AssetWRX',
    cardTitle: 'Team Invitation',
    invitedPrefix: "You've been invited to join",
    invitedRoleSuffix: 'as a {{role}}.',
    checkEmailForLink: 'Check {{email}} for a sign-in link. It brings you back here to accept.',
    signInAsEmail: 'Sign in as {{email}} to accept this invitation',
    linkSent: 'Link sent',
    emailSignInLink: 'Email me a sign-in link',
    signIn: 'Sign in',
    wrongAccountHint: 'This invite was sent to {{email}}. Sign in with that account.',
    signInDifferentAccount: 'Sign in with different account',
    accept: 'Accept',
    decline: 'Decline',
  },
  logoOrInitials: {
    logoA11y: 'Workspace logo',
    initialsA11y: 'Workspace initials',
  },
  shellTabsListA11y: 'Workspace settings sections',
  // Team management (app/team/manage.tsx) and the team store's failure sentences.
  teamManage: {
    offerFailedTitle: "Couldn't send the offer",
    tryAgain: "Try again in a moment.",
    offerSent: "{{name}} has been asked to accept ownership. Nothing changes until they do.",
    linkCopied: "Invite link copied. Send it to them however you like.",
    inviteLinkTitle: "Invite link",
    checkEmails: "Check {{emails}} and try again.",
    enterEmail: "Enter at least one email address.",
    invitesSent_one: "Invitation sent to {{email}}. They'll get an email with a link to join and appear under Members once they accept.",
    invitesSent_other: "{{count}} invitations sent. Each person gets an email with a link to join and appears under Members once they accept.",
    undeliveredTitle: "Invitation saved, email not sent",
    undeliveredBody: "We couldn't email {{emails}}. Tap Copy invite link and send it to them yourself.",
    copyInviteLink: "Copy invite link",
    ok: "OK",
    joined: "You've joined {{team}}. Work shared with the team now shows on Home and in Work.",
    joinFailedTitle: "Couldn't join the team",
    notNow: "Not now",
    declineTitle: "Decline the invitation?",
    declineBody: "Decline the invitation to {{team}}? You'll need a new invitation to join later.",
    declineFailedTitle: "Couldn't decline the invitation",
    created: "{{name}} is ready. Invite people so they can see its assets and work.",
    createFailedTitle: "Couldn't create the team",
    createFailedBody: "We couldn't create the team just now. Try again in a moment.",
    switchedTo: "Now working in {{team}}",
    switchFailedTitle: "Couldn't switch team",
    switchToA11y: "Switch to {{team}}",
    personalHint: "You're in Personal and see only your own work. Tap a team to switch to it.",
    tapToSwitchHint: "Tap a team to switch to it. Assets and work change to that team's.",
    noTeamTitle: "No team yet",
    noTeamBody: "Create a team to share assets and work with colleagues. You can invite people next.",
    adoptAssets_one: "Add your asset to {{team}}. Right now only you can see it.",
    adoptAssets_other: "Add your {{count}} assets to {{team}}. Right now only you can see them.",
    adoptFailedTitle: "Couldn't add the assets",
    membershipHint: "People you invite here can sign in and work in this team. To keep someone's details without giving them access (a contractor, a tenant), add them in Contacts.",
    emailPlaceholder: "alex@example.com\nsam@example.com",
    inviteAsA11y: "Invite as {{role}}",
    roleDescription: {
      member: "Complete and update jobs, inspections and requests.",
      admin: "Invite and remove people and change team settings.",
    },
    sendInvite_one: "Send invitation",
    sendInvite_other: "Send {{count}} invitations",
    inviteExpired: "Expired {{date}}. Tap resend to invite them again.",
    inviteSentOn: "Sent {{date}}",
    resendFailedTitle: "Couldn't resend the invitation",
    resent: "Invitation sent to {{email}} again.",
    resendA11y: "Resend invitation to {{email}}",
    cancelInviteA11y: "Cancel invitation for {{email}}",
    cancelInviteFailedTitle: "Couldn't cancel the invitation",
    cancelInviteConfirmTitle: "Cancel this invitation?",
    cancelInviteConfirmBody: "If {{email}} already has the link, it will stop working.",
    cancelInviteConfirm: "Cancel invitation",
    membersTitle: "Members · {{n}}",
    mfaPending: "{{n}} still to set up",
    mfaAllCovered: "Everyone's covered",
    mfaSocialExempt: "{{n}} sign in with Google or Apple (not needed)",
    mfaOnA11y: "{{name}} has two-factor on",
    mfaOffA11y: "{{name}} has no two-factor",
    moreActionsA11y: "More actions for {{name}}",
    yourSkills: "Your skills",
    memberSkills: "{{name}}'s skills",
    skillsSaveFailedTitle: "Couldn't save those skills",
    skillsSaveFailedBody: "Nothing was changed. Check your connection and try again.",
    saveSkills: "Save skills",
    transferBody: "Offer team ownership to {{name}}? They must accept before anything changes; you then become an admin.",
    sendOffer: "Send offer",
    resetMfaBody: "Clear {{name}}'s two-factor setup? They'll be asked to set up an authenticator app again next time they sign in. Use this when someone has lost their phone.",
    reset: "Reset",
    resetMfaDoneTitle: "Two-factor reset",
    resetMfaDone: "{{name}} can set up two-factor again next time they sign in.",
    resetMfaNothing: "{{name}} had no two-factor set up. Nothing to reset.",
    resetFailedTitle: "Couldn't reset two-factor",
    removeBody: "Remove {{name}} from the team?",
    removeBodyWithJobs_one: "Remove {{name}} from the team? {{count}} open job stays assigned to them until you reassign it.",
    removeBodyWithJobs_other: "Remove {{name}} from the team? {{count}} open jobs stay assigned to them until you reassign them.",
    remove: "Remove",
    leaveBody: "Leave {{team}}? You'll need a new invitation to join again.",
    leave: "Leave",
    leaveFailedTitle: "Couldn't leave the team",
    deleteBody: "Delete {{team}}? Its assets, inspections and jobs move back to your account. This can't be undone.",
    delete: "Delete",
    deleteFailedTitle: "Couldn't delete the team",
    renameFailedTitle: "Couldn't rename the team",
    theMember: "The member",
    noMemberMatches: "No member matches.",
    defaults: {
      companyTitle: "Company defaults",
      companyHint: "These apply across your company. You can also change them in Account → Settings.",
      teamTitle: "This team's settings",
      teamHint: "Use the company defaults, or set different ones for this team.",
      teamCurrency: "Team currency",
      teamSharing: "How this team shares work",
      sameAsCompany: "Same as company",
      setForTeam: "Set for this team",
      inUse: "In use for this team",
    },
    errors: {
      teamNotFound: "We couldn't find that team. Go back and open it again.",
      inviteNotFound: "That invitation was not found or has expired.",
      invite: "Couldn't send the invitation. Try again in a moment.",
      resend: "Couldn't resend the invitation. Try again in a moment.",
      accept: "Couldn't join the team. Check the invitation is still open and that you're signed in with the email it was sent to.",
      deleteTeam: "Couldn't delete the team. Try again in a moment.",
      onlyOwnerDelete: "Only the team owner can delete the team.",
      transfer: "Couldn't send the offer. Try again in a moment.",
      acceptTransfer: "Couldn't accept ownership. Try again in a moment.",
      declineTransfer: "Couldn't decline the offer. Try again in a moment.",
      cancelTransfer: "Couldn't cancel the offer. Try again in a moment.",
      promote: "Couldn't make them an owner. Try again in a moment.",
      demote: "Couldn't change their role. Try again in a moment.",
      alreadyMember: "This person is already in the team.",
      alreadyInvited: "An invitation has already been sent to this email.",
      noAccount: "Your workspace is still being set up. Wait a moment and try again.",
    },
  },
  featuresScreen: {
    lockedRowA11y: "{{feature}}, locked by plan. Opens the plans that include it.",
    statusNotYet: "Not available yet",
    title: "Features",
    subtitle: "What is on in this workspace. Tap a feature locked by plan to see the plans that include it.",
    simplePresetTitle: "Simple preset",
    simplePresetBody: "The starter set for a small team: assets, sites, requests, inspections, jobs, reviews, reports, contacts and maintenance plans. Insights, contractors, teams, integrations, AI and developer tools are switched off, and each is one switch away here.",
    simplePresetButton: "Use the Simple preset",
    simplePresetConfirm: "Switch off Insights, Contractors, Teams, Integrations, AI and Developer for this workspace? Each stays one switch away.",
    simplePresetApplied: "Switched to the Simple preset.",
    switchA11y: "{{feature}}: on or off for this workspace",
    switchFailed: "The change was not saved. Check your connection and try again.",
    adminHint: "Owners and admins switch features here; everyone else sees what is on.",
    statusEnabled: "Enabled",
    statusDisabled: "Disabled",
    statusLockedPlan: "Locked by plan",
    statusRestrictedRole: "Restricted by role",
    statusDisabledAdmin: "Turned off for this workspace",
    statusBeta: "Beta",
    statusDependency: "Needs another feature",
    statusUnavailable: "Not available",
    statusSetByAssetwrxOn: "On, set by AssetWRX",
    statusSetByAssetwrxOff: "Off, set by AssetWRX",
    statusLoading: "Checking…",
    modules: "Modules",
    capabilities: "Capabilities",
    empty: "No features to show yet.",
    planLabel: "Plan: {{plan}}",
    planUngated: "Plan: no limits applied",
  },
  // Features screen copy for lib/capabilities/catalog (the English there is the default; a test
  // holds these equal). Brand-only titles (WRX Vision, GraphQL, MCP …) have no key.
  featureCatalog: {
    modules: {
      assets: { title: "Assets" },
      sites: { title: "Sites" },
      requests: { title: "Requests" },
      inspections: { title: "Inspections" },
      jobs: { title: "Jobs" },
      reviews: { title: "Reviews" },
      reports: { title: "Reports" },
      analytics: { title: "Insights" },
      contacts: { title: "Contacts" },
      contractors: { title: "Contractors" },
      teams: { title: "Teams" },
      automation: { title: "Automation" },
      integrations: { title: "Integrations" },
      ai: { title: "AI" },
      administration: { title: "Administration" },
      settings: { title: "Settings" },
      developer: { title: "Developer" },
    },
    capabilities: {
      asset_360: { title: "Asset 360", description: "The Asset 360 report: verdict, scorecard, sections for the chosen reader, action plan and data quality, with an AI version on request." },
      site_360: { title: "Site 360", description: "The Site 360 report: the whole site, its buildings and areas, compliance, risk, work and contractors, with an AI version on request." },
      esg: { title: "ESG and sustainability", description: "Energy, carbon, EPC ratings and F-gas refrigerant records for sites and assets, with a portfolio view and an ESG chapter in Site 360 and Asset 360. A paid add-on." },
      esg_ai_writeup: { title: "ESG AI write-up", description: "A written ESG summary with suggested actions, made by AI from the ESG figures. Uses credits." },
      group_rules: { title: "Group rules", description: "Rules that schedule the same checklist on every matching asset, and keep it on assets added later." },
      rounds: { title: "Rounds", description: "One job that walks a checklist across several assets in order." },
      contractor_inspections: { title: "Inspections by contractors", description: "Give an inspection to a contractor with an AssetWRX account; it appears in their work and they run it with the same checklist." },
      sub_jobs: { title: "Sub-jobs", description: "A job can hold sub-jobs, each with its own person or contractor, date, checks and costs; the parent waits for them." },
      custom_asset_types: { title: "Custom asset types and fields", description: "Your own asset types with their own fields, beyond Place, Equipment, Vehicle and Other." },
      bulk_asset_setup: { title: "Bulk create and facility presets", description: "Create many places or assets at once, or a whole building from a facility preset." },
      contact_import: { title: "Contact import", description: "Import contacts from the phone's address book or a file." },
      ai_checklist_generation: { title: "AI checklist generation", description: "Draft a checklist with AI from a description, a photo or a document." },
      assistant_changes: { title: "Assistant can change records", description: "The assistant prepares new and updated assets, sites, inspections, jobs and group rules for a person to confirm." },
      assistant_planning: { title: "Assistant planning and optimisation", description: "The assistant plans days, balances workload, suggests times and advises on maintenance programmes." },
      assistant_insights: { title: "Assistant insights and briefings", description: "The assistant explains trends, costs and causes, prepares reports and gives a weekly briefing." },
      assistant_photo: { title: "Assistant photo questions", description: "Ask the assistant about a photo you take or pick." },
      assistant_voice: { title: "Assistant voice", description: "Speak to the assistant and hear its replies (needs the latest app from the store)." },
      feature_requests: { title: "Feature requests", description: "Request a feature, follow your requests and vote on ideas we are considering." },
      qr_codes: { title: "QR codes", description: "Generate and scan QR codes for asset identification." },
      barcode_scan: { title: "Barcode scan", description: "Scan barcodes to look up or capture asset identifiers." },
      condition_intelligence: { title: "Condition intelligence", description: "Rule-based asset condition, risk recommendations and technician fit on the asset and the scheduler." },
      location_tracking: { title: "Location tracking", description: "Asset location history and the claims raised by inspections, jobs and connected sources." },
      knowledge_base: { title: "Knowledge base", description: "How-tos, FAQs, notes and files on an asset, the cross-asset Knowledge search and login-free share links." },
      approvals: { title: "Approvals", description: "Approval and triage flows for requests and completions." },
      photo_capture: { title: "Photo capture", description: "Capture photos as evidence across inspections, jobs and requests." },
      video_capture: { title: "Video capture", description: "Attach short videos as evidence." },
      drawing: { title: "Drawing / markup", description: "Annotate photos with drawings and callouts." },
      voice_dictation: { title: "Voice dictation", description: "Dictate notes and field content by voice." },
      speech_recognition: { title: "Speech recognition", description: "On-device speech-to-text powering voice dictation." },
      ml_kit: { description: "On-device machine-learning primitives (labels, barcodes, text)." },
      evidence_intelligence: { title: "Evidence intelligence", description: "Analyse work evidence locally, escalating to AI only on demand." },
      wrx_vision: { description: "Scan an inspection group or item; on-device reading of meters, identifiers and barcodes, with suggestions reviewed before anything is saved." },
      wrx_vision_cloud: { title: "WRX Vision cloud analysis", description: "Cloud analysis of a Vision scan: condition, defects and not-observed checks against the checklist criteria." },
      wrx_vision_pack_fleet: { title: "WRX Vision fleet pack", description: "Vehicle damage checks: dents, scratches, glazing, lights, tyres and wheels." },
      wrx_vision_pack_equipment: { title: "WRX Vision equipment pack", description: "Plant and equipment checks: guards, leaks, hoses, cables, corrosion, plates and meters." },
      wrx_vision_pack_property: { title: "WRX Vision property pack", description: "Room and building checks: damp, mould-like growth, cracks, glazing, fittings and access." },
      wrx_vision_pack_safety: { title: "WRX Vision safety equipment pack", description: "Visual safety-equipment checks: extinguishers, alarms, signage and access. Never certifies." },
      wrx_vision_training_share: { title: "WRX Vision improvement data", description: "On by default: the evidence photos behind reviewed Vision suggestions are used to improve Vision. The workspace owner can turn it off." },
      wrx_verified: { description: "Completion evidence on jobs: expected outcomes, before/after photos, and an evidence check the reviewer decides on." },
      work_intelligence: { title: "Work intelligence", description: "Shared work-evidence analysis facade across all workflows." },
      work_planning: { description: "Plan who does what, when and in what order: people-by-time calendar, capacity, travel, parts and skills readiness, and suggested plans a person applies." },
      schedule_exceptions: { title: "Schedule governance", description: "Field requests to skip, reschedule or reassign scheduled work, and the decisions on them." },
      compliance_register: { title: "Compliance register", description: "Workspace-wide register of certificates, renewals and overdue evidence." },
      journey_intelligence: { title: "Journey intelligence", description: "AI narration and insight over operational journeys." },
      journey_analytics: { title: "Journey analytics", description: "Portfolio journey-flow dashboards and funnels." },
      power_bi_export: { title: "Power BI export", description: "Export analytics datasets for Power BI." },
      quotes: { title: "Quotes", description: "Request, compare and select contractor quotes." },
      scheduling: { title: "Scheduling", description: "Calendar planning and scheduled work." },
      recurring_work: { title: "Recurring work", description: "Recurring inspections and preventive maintenance schedules." },
      maintenance_programmes: { title: "Maintenance programmes", description: "Multi-stage maintenance programmes with meter, calendar and sequenced stages." },
      csv_import: { title: "CSV import", description: "Import contacts and assets from CSV." },
      excel_import: { title: "Excel import", description: "Import structured data from Excel workbooks." },
      power_automate: { description: "Trigger Power Automate flows from platform events." },
      iot_connectors: { title: "IoT connectors", description: "Ingest IoT signals to trigger work." },
      embed: { title: "Embedded AssetWRX", description: "Run selected AssetWRX views (Work, Assets, inspections, jobs, reports) inside another portal, without the AssetWRX app chrome." },
      embed_interactive: { title: "Interactive embeds", description: "Let embedded AssetWRX views update assets, perform inspections and change jobs, not only show them." },
      ai_summary: { title: "AI summary", description: "AI-generated summaries and drafts across surfaces." },
      ai_assistants: { title: "AI assistants", description: "Interactive AI assistants and copilots." },
      field_ai_assist: { title: "Field AI assist", description: "Dictate, improve and summarise on a text field at the point of effort." },
      industry_packs: { title: "Industry packs", description: "Install curated checklist and maintenance-plan packs, and per-asset pack suggestions." },
      offline_mode: { title: "Offline mode", description: "Work offline with automatic sync on reconnect." },
      notifications: { title: "Notifications", description: "In-app, push and email notifications." },
      rest_api: { description: "First-party REST API access." },
      graphql: { description: "GraphQL API access." },
      webhooks: { title: "Webhooks", description: "Subscribe to signed outbound webhooks." },
      mcp: { description: "Model Context Protocol access for agentic integrations." },
    },
  },
  shellTabs: {
    industryPacks: 'Industry packs',
    assetTypes: 'Asset types',
    features: "Features",
    overview: 'Overview',
    organization: 'Organization',
    defaults: 'Defaults',
    teams: 'Teams',
    reports: 'Report branding',
    integration: 'Integrations',
  },
  integrationHub: {
    ownerOnly: "Only the workspace owner, {{owner}}, can set up integrations, API keys and AI access. You can see what is connected; ask {{owner}} to set up anything new.",
    ownerOnlyUnnamed: "Only the workspace owner can set up integrations, API keys and AI access. You can see what is connected; ask your workspace owner to set up anything new.",
    askOwnerSetup: "Ask {{owner}} to set this up.",
    askOwnerSetupUnnamed: "Ask your workspace owner to set this up.",
    tryAgainShortly: "Try again in a moment.",
    loadOfflineHint: "Check this device is online, then try again.",
    conditionInvalidTitle: "Check this condition",
    conditionInvalidBody: 'For a list, type the values in square brackets, for example ["Open", "Overdue"].',
    recipeDraftCreated: "Draft recipe saved. Turn it on when you're ready.",
    retryQueued: "Retry started. The result appears in the run history.",
    importRowFailed: "Row {{row}} couldn't be saved. Check this row's values.",
    importCustomTypeUnknown: "Row {{row}}: no asset type called \"{{name}}\" for this kind, so it was saved without one.",
    importSitsInMissing: "Row {{row}}: could not find \"{{name}}\" to put it in. It was saved, not inside anything.",
    importSitsInNotAllowed: "Row {{row}}: it cannot sit in \"{{name}}\" (a place sits only in a place, a vehicle in nothing). It was saved, not inside anything.",
    importFileUnreadableTitle: "Couldn't read the file",
    importFileUnreadable: "Save it as a CSV or Excel file, then choose it again.",
    importFailed: "The import stopped. Check your file, then select Retry import.",
    apiErrors: {
      sessionExpired: 'Your session is no longer valid. Sign in again, then retry.',
      ownerOnly: 'Only the workspace owner can set up integrations, API keys and AI access. Ask your workspace owner to do this.',
      forbidden: 'You do not have access to do this.',
      sourceInactive: 'This connected source is not active. Re-enable it or rotate the token before retrying.',
      mcpAuth: 'The AI connection could not sign in. Check its key, then try again.',
      mcpUnreachable: 'Could not reach the MCP server. Check the base URL, credentials, and network access, then try again.',
      sourceToken: 'This data source token is not valid for this workspace.',
      mcpRuntime: 'The AI connection could not finish. Check its address and key, then try again.',
      mcpAdmin: 'Could not update the AI connection. Check the details and try again.',
      automationRun: 'The automation test or retry could not be completed. Review the configuration and try again.',
      automationAdmin: 'Could not save the automation. Check what you entered and try again.',
      connectedIngest: 'The device message could not be accepted. Check the token and the asset references it sends, then try again.',
      connectedAdmin: 'Could not update this data source. Check the source, rule or message and try again.',
      workspaceAdmin: 'Could not save this setting. Try again, or ask your workspace owner.',
      generic: 'The request could not be completed. Please try again.',
    },
    importRetry: 'Retry import',
    importExcelFeature: 'Excel import',
    importRetrying: 'Retrying…',
    importStopped: 'Stopped at row {{row}}: {{message}} That row and the ones after it were not imported.',
    // Data import wizard. Web downloads the samples, a phone copies them: one sentence per verb.
    importWizard: {
      step: {
        file: 'File',
        object: 'Object',
        map: 'Map',
        preview: 'Preview',
        done: 'Done',
      },
      skip: '— Skip —',
      noDefault: '— No default —',
      optionalDefault: 'Optional default…',
      sampleLeadDownload: 'New to import? Download a ready-made example (valid columns and values).',
      sampleLeadCopy: 'New to import? Copy a ready-made example (valid columns and values).',
      sampleAssetsDownload: 'Download assets sample',
      sampleAssetsCopy: 'Copy assets sample',
      sampleContactsDownload: 'Download contacts sample',
      sampleContactsCopy: 'Copy contacts sample',
      sampleAssetsA11yDownload: 'Download sample asset import CSV',
      sampleAssetsA11yCopy: 'Copy sample asset import CSV',
      sampleContactsA11yDownload: 'Download sample contact import CSV',
      sampleContactsA11yCopy: 'Copy sample contact import CSV',
      sampleCalloutDownload: 'Example spreadsheets: download the sample files from step 1 or below.',
      sampleCalloutCopy: 'Example spreadsheets: copy the sample files from step 1 or below.',
      formatReferenceShow: 'Show full data format reference',
      formatReferenceHide: 'Hide full data format reference',
    },
    webhookSecretIssued:
      'New webhook credential issued. Copy it now — it is not shown again.',
    webhookSecretReveal: 'Reveal',
    webhookSecretHide: 'Hide',
    webhookSecretCopy: 'Copy',
    webhookSecretCopied: 'Copied',
    webhookSecretDismiss: 'Dismiss',
    webhookSecretHiddenA11y: 'Webhook credential, hidden. Use Reveal to show it.',
    webhookSecretRevealedA11y: 'Webhook credential, visible on screen.',
    breadcrumb: 'Account · Workspace · Integrations',
    breadcrumbShort: 'Workspace · Integrations',
    titleShort: 'Integrations hub',
    hintShow: 'Tab tips',
    hintHide: 'Hide tips',
    eyebrow: 'Workspace integrations',
    title: 'Business-ready integrations',
    metaLine: 'Connect your business tools with API keys, webhooks, and simple automations.',
    contextHintApis: 'APIs first: create secure keys, review scopes, and open the live API reference.',
    contextHintApisGateway:
      'API keys & access: management uses your signed-in session through the workspace gateway. Create keys step by step, verify the connection, then open the live reference.',
    contextHintMcp:
      'Workspace MCP: register approved external servers, encrypt credentials, discover metadata, and keep invocation history auditable.',
    contextHintImport: 'Data import: upload spreadsheets and map your records quickly.',
    contextHintAutomations:
      'Event triggers: recipes and run history. Create service accounts and API keys in API keys & access—not here.',
    contextHintConnected:
      'Connected ingestion is its own tab: create sources, rotate per-source tokens, review inbound events and unresolved matches, then wire rules. Use API keys & access only when you want a workspace service account instead of the ingest token.',
    contextHintConnectedShort:
      'Create a source, copy the one-time token from the popup, POST JSON to the ingest URL, then add optional rules. Service-account keys live under API keys & access.',
    connectedAssetsLink: 'Connected assets',
    resourcesHelp: 'API reference (in app)',
    mainTabImport: 'Data import',
    mainTabAutomations: 'Event Triggers',
    mainTabApisAccess: 'API keys & access',
    mainTabMcp: 'MCP servers',
    mainTabConnected: 'Connected ingestion',
    guidedCategory: {
      workflow: 'Everyday workflows',
      inspection: 'Tell another system about inspections',
      job: 'Tell another system about jobs',
      asset_sync: 'Asset sync',
      inbound_webhook: 'Receive from another system',
      scheduled: 'On a schedule',
      outbound: 'Testing',
    },
    journey: {
      stage_choose: 'Choose',
      stage_configure: 'Configure',
      stage_authorise: 'Authorise',
      stage_mapping: 'Map',
      stage_preview: 'Preview',
      stage_test: 'Test',
      stage_activate: 'Activate',
      stage_monitor: 'Monitor',
      stepCounter: 'Step {{current}} of {{total}}',
      back: 'Back',
      next: 'Continue',
      finish: 'Finish',
      close: 'Close',
      loading: 'Loading…',
      testing: 'Working…',
      succeeded: 'Success',
      failed: 'Failed',
      requestId: 'Request ID',
      retry: 'Try again',
      nameLabel: 'Connection name',
      outcome_read: 'Read data from AssetWRX',
      outcome_read_desc: 'The other system pulls assets, inspections or jobs out of AssetWRX.',
      outcome_send: 'Send data to AssetWRX',
      outcome_send_desc: 'The other system creates or updates records in AssetWRX.',
      outcome_listen: 'Receive events from AssetWRX',
      outcome_listen_desc: 'AssetWRX notifies the other system when things change.',
      outcome_combination: 'A combination',
      outcome_combination_desc: 'Two-way — read, write and stay in sync.',
      createAccess: 'Create secure access',
      accessCreated: 'Secure access created',
      accessFailed: 'Could not create secure access',
      keyExpiryLabel: 'Key expiry',
      keyExpiry30: '30 days',
      keyExpiry90: '90 days',
      keyExpiry365: '1 year',
      keyExpiryNever: 'Never',
      apiKeyLabel: 'API key',
      customScopesHint: 'Turn on only the access this connection needs.',
      elevatedScopeHelp: 'Need unrestricted access? Review and create it in the advanced console.',
      matchField: 'Record matching',
      matchExternalId: 'Match assets by external ID',
      idempotencyPolicy: 'Repeated source events use the same source event ID, so retries do not create duplicate work.',
      conflictPolicy: "When both systems changed a record",
      conflictPolicyNote: "Your IT team builds this rule into the sync; AssetWRX shows it on the connection page for them. To avoid duplicates, the sync looks each asset up by its external ID before creating one.",
      conflict_manual_review: "Ask a person",
      conflict_manual_review_desc: "Safest. Your system does not overwrite a record someone changed in AssetWRX; it flags it for a person to check.",
      conflict_source_wins: "Your system wins",
      conflict_source_wins_desc: "Your system updates the AssetWRX record that has the same external ID.",
      conflict_assetwrx_wins: "AssetWRX wins",
      conflict_assetwrx_wins_desc: "Your system leaves records that were changed in AssetWRX as they are.",
      previewTitle: 'Review before testing',
      previewHint: 'Confirm the business purpose, access and processing rules. Testing will not activate the connection.',
      previewConnection: 'Connection',
      previewAccess: 'Access',
      previewDestination: 'Destination',
      previewEvents: 'Events',
      previewScopeCount_one: "{{count}} least-privilege scope",
      previewScopeCount_other: "{{count}} least-privilege scopes",
      previewConflict: 'Conflict policy',
      previewProviderDefault: 'Provider-safe default',
      previewRetry: 'Retries',
      previewIdempotent: 'Idempotent; duplicate events are ignored',
      secretOnce: 'Copy this now — for your security it cannot be shown again.',
      secretSaved: 'I have saved this securely',
      copy: 'Copy',
      copied: 'Copied',
      testConnection: 'Test connection',
      testStatusExplain:
        "We'll call the read-only status endpoint with your new key to confirm it works. Nothing is created or changed.",
      connected: 'Connected',
      connectedDetail: 'AssetWRX accepted the credentials and responded successfully.',
      connectionFailed: 'Connection failed',
      quickStartExplain: 'Point your app at this base URL and send your key in the x-asset-inspector-key header.',
      baseUrlLabel: 'Base URL',
      firstRequestLabel: 'First request',
      quickStartKeyNote: 'Replace YOUR_API_KEY with the key you just saved. We never store it in examples.',
      ready: 'Your connection is ready',
      readyDetail: 'You can manage it any time from Your connections.',
      activating: 'Switching it on…',
      activateFailed: 'Your connection is not on yet',
      activateFailedDetail: 'Select Try again. Nothing has been switched on yet.',
      done: 'Done',
      na_openGuides: 'Open developer guides',
      na_openReference: 'Open the API reference',
      na_setupEvents: 'Set up events',
      na_createAutomation: 'Create automation',
      na_manageSource: 'Manage source & rules',
      identifierExplain:
        'Each incoming event needs to say which asset it belongs to. Choose how your devices will identify assets.',
      idKind_external: 'External ID',
      idKind_qr: 'QR code',
      createSource: 'Create data source',
      sourceCreated: 'Data source created',
      sourceFailed: 'Could not create the data source',
      ingestTokenLabel: 'Ingest token',
      ingestAddressLabel: "Address the devices send to",
      ingestHowTo: "Give the device team this address and the ingest token. Each message is an HTTPS POST to the address with the token in the x-connected-source-token header.",
      sendAnotherTest: "Try another identifier",
      sendTestExplain: 'Send one safe test event now. Optionally enter one of your real asset identifiers to see a live match.',
      testIdentifierLabel: 'Asset identifier (optional)',
      sendTestEvent: 'Send test event',
      eventMatched: 'Event received · asset matched',
      eventMatchedDetail: 'AssetWRX accepted the event and linked it to the matching asset.',
      eventUnmatched: 'Event received · asset not identified',
      eventUnmatchedDetail:
        "The pipeline works — we just couldn't match this identifier to an asset. Enter a real asset identifier, or resolve it later in Connected events.",
      eventFailed: 'The event was rejected',
      title_business: 'Connect a business system',
      business_choose_title: 'What are you connecting?',
      business_choose_hint: 'Give it a name you will recognise and pick the kind of system.',
      business_outcome_title: 'What do you want it to do?',
      business_outcome_hint: 'This helps us recommend the right secure access.',
      business_mapping_title: 'Map records and conflicts',
      business_mapping_hint: 'Use stable external identifiers and decide what happens when both systems changed a record.',
      business_access_title: 'Create secure access',
      business_access_hint: 'AssetWRX creates a service account and a single API key for this connection.',
      business_test_title: 'Test the connection',
      business_activate_title: 'Finish',
      sys_erp: 'ERP',
      sys_crm: 'CRM',
      sys_finance: 'Finance',
      sys_maintenance: 'Maintenance',
      sys_data: 'Data platform',
      sys_custom: 'Custom application',
      sys_other: 'Other',
      title_developer: 'Build a custom application',
      dev_choose_title: 'Name your application',
      dev_choose_hint: 'This labels the API key so you can find it later.',
      dev_access_title: 'Create secure access',
      dev_access_hint: 'Pick the least access this application needs. Unrestricted access is in the Advanced console.',
      dev_quickstart_title: 'Make your first request',
      dev_activate_title: 'Finish',
      title_iot: 'Connect a data source',
      iot_choose_title: 'Name the source',
      iot_choose_hint: 'What is sending data into AssetWRX?',
      iot_configure_title: 'How will assets be identified?',
      iot_token_title: 'Secure the source',
      iot_token_hint: 'Devices send this token in the x-connected-source-token header.',
      iot_test_title: 'Send the first event',
      iot_activate_title: 'Finish',
      src_device: 'Device / sensor',
      src_gateway: 'IoT gateway',
      src_platform: 'IoT platform',
      src_external: 'External system',
      title_webhook: 'Create an event connection',
      wh_choose_title: 'Name this event connection',
      wh_choose_hint: 'When something happens in AssetWRX, where should we send it?',
      wh_configure_title: 'Destination and events',
      wh_secret_title: 'Generate signing secret',
      wh_test_title: 'Send a test event',
      wh_activate_title: 'Activate',
      destUrlLabel: 'Destination URL',
      destUrlError: 'Enter a valid https:// URL.',
      chooseEvents: 'Which changes should we send?',
      signingExplain: 'Verify this signature on every delivery to confirm it really came from AssetWRX.',
      signingSecretLabel: 'Signing secret',
      generateSecret: 'Generate signing secret',
      webhookCreated: 'Event connection created',
      webhookFailed: 'Could not create the event connection',
      webhookTestExplain: 'Send a signed test delivery to your endpoint now to confirm it can receive events.',
      sendTestDelivery: 'Send test delivery',
      webhookTestSent: 'Test event delivered',
      webhookTestDetail: 'Your endpoint accepted a signed {{event}} delivery{{http}}.',
      webhookTestRejected: 'Your endpoint did not accept the test event',
      webhookTestFailed: 'Could not send the test event',
      na_viewDeliveries: 'View deliveries',
      evtgrp_assets: 'Assets',
      evt_asset_created: 'Asset created',
      evt_asset_updated: 'Asset updated',
      evt_asset_deleted: 'Asset deleted',
      evtgrp_inspections: 'Inspections',
      evt_inspection_created: 'Inspection created',
      evt_inspection_updated: 'Inspection updated',
      evt_inspection_completed: 'Inspection completed',
      evtgrp_wrx: 'WRX (jobs)',
      evt_job_created: 'WRX created',
      evt_job_status: 'WRX status changed',
      evt_job_completed: 'WRX completed',
      evtgrp_contacts: 'Contacts',
      evt_contact_created: 'Contact created',
      evt_contact_updated: 'Contact updated',
      evtgrp_connected: 'Connected data',
      evt_connected_received: 'Connected event received',
      evt_connected_unresolved: 'Connected event unmatched',
      evt_connected_alert: 'Connected alert raised',
      title_automation: 'Automate a process',
      auto_choose_title: 'What do you want to automate?',
      auto_choose_hint: 'Pick a starting point. You can fine-tune everything afterwards.',
      auto_configure_title: 'Create the automation',
      auto_configure_hint: 'A few choices, then read the sentence — that is exactly what will happen.',
      auto_test_title: 'Test the automation',
      auto_activate_title: 'Finish',
      tmpl_inspection_issue: 'When an inspection is completed',
      tmpl_wrx_completed: 'When a WRX is completed',
      tmpl_wrx_status: 'When a WRX status changes',
      tmpl_asset_changed: 'When an asset changes',
      tmpl_scratch: 'Start from scratch',
      tmpl_inbound_webhook: 'When another system calls your webhook',
      tmpl_action_create_wrx: 'Create a work request (WRX)',
      tmpl_action_send_event: 'Send it to your webhook',
      tmpl_action_notify: 'Notify another system',
      tmpl_action_choose: 'You choose in the builder',
      tmpl_action_inbound_wrx: 'Create a WRX from the request',
      automationCreateExplain:
        "We'll create this automation as a draft. You add the exact conditions and actions in the builder, then activate it.",
      createAutomation: 'Create automation',
      automationCreated: 'Automation drafted',
      automationFailed: 'Could not create the automation',
      automationTestExplain:
        'Run the automation once now to confirm the trigger is wired. Draft automations do not fire on their own.',
      runTest: 'Run test',
      automationRan: 'Test run completed',
      automationRanDetail: 'Run status: {{status}}. Add actions in the builder to make it do work.',
      automationCreateExplain2:
        "We'll create this automation with its trigger and a first action, ready to test and activate.",
      automationCreatedWithAction: 'Automation created',
      automationDraftDetail: 'Add the actions this should perform in the builder.',
      automationInboundReady: 'Your inbound webhook URL and token are shown below. Copy the token now.',
      automationDestUrlLabel: 'Where should we send it?',
      automationDestUrlHint: 'We POST each matching event to this HTTPS URL, signed so you can verify it.',
      automationInboundOnce: 'This is your inbound webhook. Copy the token now - it cannot be shown again.',
      automationInboundUrlLabel: 'Webhook URL (POST here)',
      automationInboundTokenLabel: 'Secret token',
      autoJobTitle: 'Automated work request',
      automationRanDetail2: "Run status: {{status}}. This ran the automation's action once with sample data.",
      automationRunFailed: 'Test run failed',
      na_openBuilder: 'Open the automation builder',
      title_ai: 'Connect an AI agent',
      ai_choose_title: 'Name the AI connection',
      ai_choose_hint: 'For example, the assistant or agent you want to connect.',
      ai_nameLabel: 'Name this connection',
      ai_modeLabel: 'How do you want to connect?',
      ai_modeFirstParty: 'Let an AI assistant use AssetWRX',
      ai_modeFirstPartyDesc: 'Turn on AssetWRX MCP server so approved assistants can securely read and propose actions.',
      ai_modeExternal: 'Connect an external MCP server',
      ai_modeExternalDesc: 'Register a third-party MCP server by its URL so AssetWRX can call its tools and resources.',
      mcpExternalExplain: 'Enter the MCP server HTTPS URL and how AssetWRX should authenticate to it.',
      mcpBaseUrlLabel: 'Server URL',
      mcpAuthLabel: 'Authentication',
      mcpAuthNone: 'No auth',
      mcpAuthBearer: 'Bearer token',
      mcpAuthApiKey: 'API key',
      mcpAuthCustom: 'Custom header',
      mcpHeaderNameLabel: 'Header name',
      mcpSecretPlaceholder: 'Secret / token',
      mcpRegister: 'Register server',
      mcpRegistered: 'External server registered',
      mcpRegisterFailed: 'Could not register the server',
      mcpNoKeyExplain: 'This connection uses the credentials you just entered for the external server. No AssetWRX key is needed.',
      mcpExternalTestExplain: 'We will connect to the server and list the tools and resources it exposes.',
      mcpTestConnection: 'Test connection',
      mcpTestFailed: 'Could not reach the server',
      mcpConnected: 'Connected to the server',
      mcpDiscovered: 'Found {{tools}} tools and {{resources}} resources.',
      ai_enable_title: 'Allow AI access',
      ai_access_title: 'Choose access level',
      ai_access_hint: 'Pick what the AI can see and do. It can only propose changes, which still need confirmation.',
      ai_test_title: 'Verify the connection',
      ai_activate_title: 'Finish',
      mcpExplain:
        'Approved AI assistants and agents can securely read selected AssetWRX information and propose actions. Every change an AI proposes still needs confirmation.',
      mcpEndpointLabel: 'AI connection endpoint',
      enableAi: 'Enable AI access',
      mcpEnabled: 'AI access enabled',
      mcpEnableFailed: 'Could not enable AI access',
      mcpVerifyExplain: "We'll confirm the key works and the AI connector is reachable. Nothing is changed.",
      verifyAi: 'Verify AI connection',
      mcpActive: 'AI connection is active',
      mcpDegraded: 'AI connection enabled',
      mcpVerifyDetail: 'The key works and the AI connector responded. Approved agents can now connect.',
      mcpVerifyFailed: 'Could not verify the AI connection',
      na_reviewActivity: 'Review AI activity',
      title_files: 'Set up file exchange',
      files_choose_title: 'Name this file connection',
      files_choose_hint: 'Upload documents and files to AssetWRX, or download them, with short-lived secure links.',
      files_access_title: 'Create secure access',
      files_access_hint: 'Asset operations covers upload and download; Read only covers download only.',
      files_test_title: 'Test file exchange',
      files_activate_title: 'Finish',
      na_openFilesGuide: 'Open the files guide',
      filesReady: 'File exchange is ready',
      filesReadOnlyDetail: "This key can download files but not upload them, so we checked that it signs in. Download links work for files already in AssetWRX.",
      filesReadyReadOnly: "File exchange is ready (download only)",
      filesBothDetail: 'Signed upload and download links were issued successfully.',
      filesUploadDetail: 'A signed upload link was issued. Downloads use the same secure-link mechanism.',
      filesTestFailed: 'Could not issue signed links',
      filesTestExplain: "We'll ask AssetWRX for a short-lived signed upload link with your new key. Nothing is uploaded — this just proves the connection can move files.",
      filesObjectKey: 'Sample object key',
      filesTest: 'Test file exchange',
      automationScratchExplain: "We’ll create an empty automation you can build up in the advanced builder.",
      automationEventReady: "Ready to run on its own",
      automationEventTestExplain: "This one runs by itself when the workspace does the thing it watches for. Nothing to press — you will see every run in its history.",
    },
    home: {
      eyebrow: 'Workspace integrations',
      title: 'What do you want to achieve?',
      subtitle:
        'Choose the business result. AssetWRX will guide the secure setup, test and activation.',
      resumeTitle: 'Resume setup',
      discardDraft: 'Discard saved setup',
      card_business_title: 'Connect another business system',
      card_business_desc:
        'Connect an ERP, CRM, finance platform, maintenance system or another business application.',
      card_business_cta: 'Connect a system',
      card_webhook_title: 'React when something happens',
      card_webhook_desc: 'Send events to another system when an asset, inspection, job or request changes.',
      card_webhook_cta: 'Create event connection',
      card_automation_title: 'Automate a process',
      card_automation_desc:
        'Automatically perform actions when something happens in AssetWRX or another connected system.',
      card_automation_cta: 'Create automation',
      card_iot_title: 'Connect sensors and devices',
      card_iot_desc: 'Bring readings from sensors and devices into AssetWRX and link them to the right asset.',
      card_iot_cta: 'Connect a data source',
      card_ai_title: 'Connect an AI agent',
      card_ai_desc: 'Allow approved AI assistants and agents to securely work with AssetWRX.',
      card_ai_cta: 'Connect AI',
      card_developer_title: 'Build a custom application',
      card_developer_desc: 'Use the AssetWRX API to build custom applications and integrations.',
      card_developer_cta: 'Start building',
      card_files_title: 'Exchange files',
      card_files_desc: 'Upload documents and files to AssetWRX, or download them, using short-lived secure links.',
      card_files_cta: 'Set up file exchange',
      card_import_title: 'Import records from a spreadsheet',
      card_import_desc: 'Bring assets or contacts in from a CSV or Excel file. Map your columns to the right fields, preview, then create the records.',
      card_import_cta: 'Import from a file',
      card_power_bi_title: 'Report in Power BI',
      card_power_bi_desc: 'Load assets, inspections and jobs into Power BI or Excel, refreshed on your schedule.',
      card_power_bi_cta: 'Set up Power BI',
      card_power_automate_title: 'Use Power Automate',
      card_power_automate_desc: 'Start Microsoft flows when work changes, and raise jobs and inspections from your flows.',
      card_power_automate_cta: 'Set up Power Automate',
      tier_start_title: 'Start simple',
      tier_start_subtitle: 'Guided step by step. Some give you a key to pass to whoever runs the other system.',
      tier_data_title: 'Data, events and automation',
      tier_data_subtitle: 'Move data, react to changes, and automate work.',
      tier_dev_title: 'Developer and AI',
      tier_dev_subtitle: 'Build on the API and connect AI agents.',
      connectionsTitle: 'Your connections',
      connectionsEmptyTitle: 'No connections yet',
      connectionsEmptyDesc: 'Pick an outcome above to connect your first system.',
      connectionsEmptyMember: 'Your workspace owner sets up connections.',
      connectionsLoadFailed: "Couldn't load your connections.",
      connectionsRetry: 'Try again',
      lockedSubtitle: 'Connect other systems, automate work and link sensors or AI agents.',
      activityNever: 'No activity yet',
      status_draft: 'Draft',
      status_testing: 'Testing',
      status_active: 'Active',
      status_paused: 'Paused',
      status_error: 'Attention required',
      status_archived: 'Inactive',
      devToolsTitle: 'Developer tools',
      dev_api_title: 'API reference',
      dev_api_subtitle: 'Browse the live REST & GraphQL reference.',
      dev_docs_title: 'Guides & documentation',
      dev_docs_subtitle: 'Task-based guides, examples and troubleshooting.',
      dev_advanced_title: 'Advanced console',
      dev_advanced_subtitle: 'Every key, AI access, automation and incoming data setting in one place.',
      dev_keys_title: 'API keys',
      dev_keys_subtitle: 'Create, rotate and revoke the keys your integrations use.',
      dev_ai_title: 'AI assistant access',
      dev_ai_subtitle: 'Choose what outside AI assistants can see and do, and approve their changes.',
      devTitle: 'Connect, build and automate',
      devSectionTitle: 'Developer & reference',
      devSectionSubtitle: 'For teams that connect systems directly, give AI assistants access, or manage keys.',
      devSectionSubtitleApi: 'For teams that connect systems directly or manage keys.',
      devSectionSubtitleMcp: 'For teams that give AI assistants access, with step-by-step guides.',
      devSectionSubtitleGuides: 'Guides, examples and troubleshooting for your integrations.',
      journeyUnavailableTitle: 'Not available yet',
      journeyUnavailableDesc: 'This journey is being set up. Please check back shortly.',
    },
    connection: {
      type_business_system: 'Business system',
      type_event_webhook: 'Webhook',
      type_automation: 'Automation',
      type_iot_connected: 'Sensors and IoT',
      type_ai_mcp: 'AI agent',
      type_developer_app: 'Custom application',
      type_file_exchange: 'File exchange',
      overview: 'Overview',
      lastActivity: 'Last activity',
      source: 'Source',
      sourceManaged: 'Managed connection',
      sourceDerived: 'Derived from an existing resource',
      whatsConnected: "What's connected",
      noResources: 'No linked resources.',
      activity: 'Recent activity',
      activityEmpty: 'No recent activity to show yet.',
      health_healthy: 'Healthy',
      health_attention: 'Attention required',
      health_inactive: 'Inactive',
      health_active: 'Active',
      health_degraded: 'Degraded',
      health_paused: 'Paused',
      health_revoked: 'Revoked',
      healthTitle: 'Connection health',
      lastSuccess: 'Last success',
      lastFailure: 'Last failure',
      noFailure: 'None recorded',
      affectedObjects: 'Affected objects',
      recovery_manage: 'Manage connection',
      recovery_recover: 'Review failure and reconnect',
      recovery_resume: 'Resume connection',
      recovery_review_history: 'Review access history',
      notFoundTitle: 'Connection not found',
      notFoundDesc: 'It may have been removed. Return to the integration home.',
      actionFailed: 'Could not update the connection.',
      archiveTitle: 'Revoke connection access?',
      archiveMsg: 'Access will stop immediately. Configuration and activity history will remain available for audit.',
      archive: 'Revoke access',
      pause: 'Pause',
      activate: 'Activate',
      openAdvanced: 'Open in advanced console',
      kind_service_account: 'API key',
      kind_webhook_subscription: 'Event connection (webhook)',
      kind_connected_source: 'Connected data source',
      kind_mcp_server: 'AI / MCP server',
      kind_automation_recipe: 'Automation recipe',
    },
    docs: {
      title: 'Guides & documentation',
      subtitle: 'Task-based guides, working examples and troubleshooting.',
      notFound: 'Guide not found',
      achieve: "What you'll achieve",
      need: 'What you need',
      steps: 'Steps',
      verify: 'How you know it worked',
      failure: 'If it fails',
      next: 'What to do next',
      rawHandbook: 'Raw handbook (advanced)',
      minutes_one: '{{count}} min',
      minutes_other: '{{count}} min',
      minutesRead_one: '{{count}} min read',
      minutesRead_other: '{{count}} min read',
      section: {
        gettingStarted: { title: 'Getting started', description: 'Connect your first system and make your first call.' },
        guides: { title: 'Guides', description: 'Connect common systems and platforms, step by step.' },
        api: { title: 'API', description: 'REST, GraphQL, authentication, errors and request IDs.' },
        events: { title: 'Events', description: 'Outbound webhooks, signatures, retries and idempotency.' },
        automation: { title: 'Automation', description: 'Triggers, conditions and actions.' },
        connected: { title: 'Connected data', description: 'Send device and sensor data and match it to assets.' },
        aiMcp: { title: 'AI & MCP', description: 'Let approved AI agents work with AssetWRX safely.' },
        security: { title: 'Security', description: 'Least privilege, key rotation and audit history.' },
        troubleshooting: { title: 'Troubleshooting', description: 'Fix the most common integration problems by symptom.' },
      },
      guide: {
        integrationOverview: { title: 'Integration overview', summary: 'How AssetWRX connects to other systems.' },
        connectFirstSystem: { title: 'Connect your first system', summary: 'Create secure access and see it working.' },
        authentication: { title: 'Authentication', summary: 'How to authenticate API requests.' },
        makeFirstRequest: { title: 'Make your first API request', summary: 'Call the API and read a successful response.' },
        connectErp: { title: 'Connect an ERP', summary: 'Give your ERP (or another business system) its own secure access to AssetWRX, then hand over to IT to finish the ERP side.', time: '20 min, plus IT time' },
        connectPowerAutomate: { title: 'Connect Power Automate', summary: 'Create AssetWRX jobs and inspections from your Microsoft flows, and start a flow whenever something changes in AssetWRX.' },
        connectPowerBi: { title: 'Report in Power BI', summary: 'Bring your assets, inspections and jobs into Power BI or Excel, refreshed on a schedule.' },
        embedInAPortal: { title: 'Show AssetWRX inside another portal', summary: 'Put AssetWRX screens (Work, an asset, an inspection, a job) inside your customer portal or intranet.', time: '15 min for you, plus your web team' },
        embedInDynamics: { title: 'Show AssetWRX in Dynamics 365', summary: 'The AssetWRX asset on the Dynamics 365 Customer Asset form, signed in with Microsoft, refreshing the form when work is done.', time: '30 min for you, about an hour for IT' },
        sendIotData: { title: 'Send sensor and device data', summary: 'Let sensors, gateways or another system send readings and alerts into AssetWRX, matched to the right asset.', time: '15 min, plus device team time' },
        receiveEvents: { title: 'Receive AssetWRX events', summary: 'Have AssetWRX send a message to another system whenever an asset, inspection, job or request changes.', time: '15 min, plus IT time' },
        connectAiAgent: { title: 'Connect an AI agent', summary: 'Let an approved AI assistant read your AssetWRX information and ask for changes that a person approves.', time: '15 min, plus AI tool setup' },
        uploadDownloadFiles: { title: 'Upload & download files', summary: 'Let another system send files to AssetWRX and fetch them again, using short-lived secure links.', time: '10 min, plus IT time' },
        restApi: { title: 'REST API', summary: 'Resources, methods and shapes.' },
        paginationErrors: { title: 'Pagination, errors & request IDs', summary: 'Read lists page by page and diagnose failures.' },
        permissionsScopes: { title: 'Permissions & scopes', summary: 'What each scope allows.' },
        webhooks: { title: 'Webhooks', summary: 'How outbound deliveries work.' },
        signatureVerification: { title: 'Signature verification', summary: 'Confirm a delivery really came from AssetWRX.' },
        automationGettingStarted: { title: 'Automation: getting started', summary: 'Triggers, conditions and actions.' },
        assetMatching: { title: 'Asset matching', summary: 'How events are linked to assets.' },
        unresolvedEvents: { title: 'Unresolved events', summary: 'Fix events that did not match an asset.' },
        mcpOverview: { title: 'AI & MCP overview', summary: 'How AI connections work.' },
        mcpSecurity: { title: 'AI security & approval model', summary: 'Keep AI access safe.' },
        leastPrivilege: { title: 'Least privilege', summary: 'Grant only what a connection needs.' },
        keyRotation: { title: 'Key rotation & revocation', summary: 'Replace or disable keys safely.' },
        auditHistory: { title: 'Audit history', summary: 'See who did what.' },
        apiRejected: { title: 'My API call is rejected', summary: '401 / 403 and validation errors.' },
        webhookNotArriving: { title: 'My webhook is not arriving', summary: 'Deliveries never reach your endpoint.' },
        eventNoAsset: { title: 'My event cannot find an asset', summary: 'Connected events land unresolved.' },
        automationDidNotRun: { title: 'My automation did not run', summary: 'A recipe did not fire.' },
        aiCannotConnect: { title: 'My AI agent cannot connect', summary: 'The AI connection fails.' },
      },
    },
    access: {
      title: 'Secure access',
      notFound: 'The service account for this connection is unavailable.',
      keyCount: '{{active}} active key(s)',
      statusActive: 'Active',
      statusRevoked: 'Revoked',
      permissions: 'Permissions',
      keys: 'API keys',
      keyLine: '{{scopeCount}} scopes · created {{created}}',
      expires: 'expires',
      rotate: 'Rotate key',
      rotateFailed: 'Could not rotate the key.',
      revokeFailed: 'Could not revoke. The key still works.',
      revoke: 'Revoke',
      rotateTitle: 'Rotate this key?',
      rotateMsg: 'The current key stops working now. Give the new key to Power BI, Power Automate or your system straight away.',
      revokeKeyTitle: 'Revoke this key?',
      revokeKeyMsg: 'Calls using it stop working immediately.',
      revokeAll: 'Revoke access',
      revokeAllTitle: 'Revoke all access?',
      revokeAllMsg: 'The service account and every key are revoked immediately. This cannot be undone.',
      done: 'I have saved this',
    },
    connected: {
      title: 'Connected ingestion',
      notFound: 'The data source for this connection is unavailable.',
      statusActive: 'Active',
      statusPaused: 'Paused',
      statusDisabled: 'Disabled',
      tokenEnding: 'Token ending {{last}}',
      rotateToken: 'Rotate ingest token',
      rotateFailed: 'Could not rotate the token.',
      pause: 'Pause',
      resume: 'Resume',
      resolveFailed: 'Could not resolve the event.',
      unresolvedTitle: 'Needs attention',
      unresolvedEmpty: 'No unresolved events.',
      reasonAmbiguous: 'Matched more than one asset',
      reasonNoMatch: 'No matching asset',
      resolveWith: 'Resolve as',
      resolveInAdvanced: 'Resolve in advanced console',
      rulesTitle: 'Rules',
      rulesEmpty: 'No rules yet.',
      manageRules: 'Manage rules',
      cancel: 'Cancel',
      newRule: '+ New rule',
      ruleNameLabel: 'Rule name (optional)',
      ruleNamePlaceholder: 'e.g. High-temperature alert',
      matchLabel: 'Which events?',
      matchAll: 'All events',
      matchPrefix: 'Starts with',
      actionLabel: 'Then',
      actionAlert: 'Raise an alert',
      actionReposition: 'Update the location',
      actionPublish: 'Publish an event',
      actionJob: 'Create a WRX',
      actionValueLabel: 'Action detail',
      valueAlertPlaceholder: 'Alert title (optional)',
      valueJobPlaceholder: 'WRX title (optional)',
      createRule: 'Create rule (paused)',
      ruleCreateFailed: 'Could not create the rule.',
      ruleUpdateFailed: 'Could not update the rule.',
      ruleActivate: 'Activate',
      rulePause: 'Pause',
      ruleAdvancedNote: 'Need conditions or a checklist? Open the advanced console.',
      eventsTitle: 'Recent events',
      eventsEmpty: 'No events received yet.',
      reprocess: 'Reprocess',
      reprocessFailed: 'Could not reprocess the event.',
    },
    automation: {
      title: 'Automation',
      notFound: 'The automation for this connection is unavailable.',
      status_active: 'Active',
      status_paused: 'Paused',
      status_draft: 'Draft',
      status_archived: 'Archived',
      trigger: 'Trigger',
      steps_one: "{{count}} action",
      steps_other: "{{count}} actions",
      runResult: 'Test run: {{status}}',
      runFailed: 'Could not run the automation.',
      activate: 'Activate',
      pause: 'Pause',
      runNow: 'Run now',
      editInBuilder: 'Edit in builder',
      actionFailed: 'Action failed.',
      historyTitle: 'Run history',
      historyEmpty: 'No runs yet.',
      retry: 'Retry',
      inboundTitle: 'Inbound webhook',
      inboundUrl: 'Webhook URL (POST here)',
      inboundNone: 'Generate a secret to activate the inbound URL.',
      inboundToken: 'Secret token (shown once)',
      rotateSecret: 'Rotate secret',
      lastRun: "Last run",
      never: "Never",
      nextRun: "Next run",
      testRun: "Test run",
      turnOn: "Turn on",
      edit: "Edit",
      hideSkipped: "Hide skipped",
      showSkipped_one: "{{count}} skipped",
      showSkipped_other: "{{count}} skipped",
      historyEmptyEvent: "Nothing has happened yet — it runs by itself when the workspace does.",
      historyOnlySkipped: "Every run so far was skipped.",
      fix: "Fix this automation",
    },
    mcp: {
      title: 'AI connection (MCP)',
      notFound: 'The MCP server for this connection is unavailable.',
      statusActive: 'Active',
      statusDisabled: 'Disabled',
      statusError: 'Error',
      toolsResources: '{{tools}} tools · {{resources}} resources',
      test: 'Test connection',
      testOk: 'Connected · {{protocol}}',
      testFail: 'Connection failed',
      discover: 'Discover metadata',
      discovered: '{{tools}} tools · {{resources}} resources',
      discoverFailed: 'Could not discover metadata.',
      enable: 'Enable',
      disable: 'Disable',
      invocationsTitle: 'Recent activity',
      invocationsEmpty: 'No activity yet.',
      manageAdvanced: 'Manage in advanced console',
      actionFailed: 'Action failed.',
      credentials: 'Credentials',
      credentialsTitle: 'Update credentials',
      credentialsSaved: 'Credentials updated',
      credentialsFailed: 'Could not update credentials.',
      auth_none: 'No auth',
      auth_bearer: 'Bearer',
      auth_api_key: 'API key',
      auth_custom_header: 'Custom header',
      headerName: 'Header name',
      secretPlaceholder: 'Secret / token',
      saveCredentials: 'Save credentials',
    },
    files: {
      title: "Files exchanged",
      empty: "No files yet. Files your systems upload to this workspace, through any file connection, appear here.",
      loadFailed: "Could not load the files.",
      download: "Download",
      downloadFailed: "Could not download the file.",
    },
    webhook: {
      title: "Events",
      unavailable: "The event subscription for this connection could not be loaded.",
      address: "Sends to",
      secretEnding: "Signing secret ending {{last}}",
      secretLabel: "Signing secret",
      replace: "Replace signing secret",
      replaceTitle: "Replace the signing secret?",
      replaceMsg: "Events are signed with the new secret straight away, so the receiving system rejects them until it has the new one. Give it the new secret at once.",
      replaceFailed: "Could not replace the signing secret.",
    },
    embeddedApps: {
      refusal_other: "something went wrong starting the session. Try again; if it repeats, contact AssetWRX support.",
      refusal_assertion: "the portal's proof of who the person is was not accepted. Ask your IT team to check the sign-in settings.",
      refusal_scope_denied: "the portal asked for something this app is not allowed to do.",
      refusal_jit_refused: "the person could not be added automatically.",
      refusal_unknown_user: "the person is not linked to anyone in this workspace.",
      refusal_jit_domain_refused: "the person's email domain is not on the allowed list.",
      refusal_identity_unlinked: "an admin unlinked this person. Link them again below.",
      refusal_identity_collision: "that sign-in already belongs to someone else here.",
      refusal_user_disabled: "the person's AssetWRX account is switched off.",
      refusal_wrong_tenant: "the person used a Microsoft account from another company.",
      refusal_sso_required: "the person did not sign in with Microsoft.",
      refusal_not_entitled: "the workspace's plan does not include embedding.",
      refusal_view_not_permitted: "the view needs a permission this app does not have.",
      refusal_not_a_member: "the person is not a member of this workspace.",
      refusal_bootstrap_expired: "the person took longer than a minute to sign in. Reloading the portal page fixes it.",
      lastRefusalReason: "Last refusal: {{reason}}",
      viewNeedsScope: "These views cannot open until you tick their permission under What it may do: {{views}}.",
      viewsHelp: "Ticking a view also ticks the permission it needs under What it may do.",
      disableMsg: "Every portal using it stops showing AssetWRX straight away, and open sessions end. You can turn it back on at any time.",
      disableTitle: "Turn off {{name}}?",
      removeOriginConfirm: "Remove site",
      removeOriginMsg: "That site stops showing AssetWRX straight away. People using it there see an empty space until you add it again.",
      removeOriginTitle: "Remove {{origin}}?",
      removeOriginShort: "Remove",
      outcomeCta: "Set up an embedded app",
      outcomeTitle: "Show AssetWRX in another portal",
      ownerOnlyBodyUnnamed: "Ask your workspace owner to add one. The guides above show what they will need.",
      ownerOnlyBody: "Ask {{owner}} to add one. The guides above show what they will need.",
      ownerOnlyTitle: "Only the workspace owner can set up embedded apps",
      title: "Embedded apps",
      subtitle: "Show AssetWRX inside another portal, such as Dynamics 365 or a customer portal. Choose which sites may host it, which views they can open and what those views may do.",
      cardSubtitle: "Show AssetWRX views inside another portal.",
      guidePortal: "How to set this up",
      guideDynamics: "Set up Dynamics 365",
      create: "New embedded app",
      defaultName: "Embedded app",
      loadFailed: "Could not load your embedded apps. They have not been changed.",
      emptyTitle: "No embedded apps yet",
      emptyDesc: "Create one to choose which portal may host AssetWRX and what it may show.",
      adminOnly: "Only workspace owners and admins can manage embedded apps.",
      name: "Name",
      save: "Save",
      statusActive: "On",
      statusDisabled: "Off",
      enable: "Turn on",
      disable: "Turn off",
      publicId: "Public ID",
      publicIdHelp: "The host portal passes this ID. It is not a secret and grants nothing on its own.",
      secretTitle: "Host secret",
      secretHelp: "Your portal's server uses this to start embedded sessions. Keep it on the server, never in a web page.",
      secretNone: "No secret yet. The portal cannot open AssetWRX until you create one.",
      secretSet: "Secret {{prefix}}… created {{date}}",
      secretCreate: "Create secret",
      secretRotate: "Replace secret",
      secretRotateTitle: "Replace the host secret?",
      secretRotateMsg: "The current secret stops working straight away. Update your portal's server with the new one.",
      secretShownOnce: "Copy this now. It will not be shown again.",
      origins: "Allowed sites",
      originsHelp: "Exact addresses only, such as https://contoso.crm.dynamics.com. Wildcards are not allowed.",
      originPlaceholder: "https://example.com",
      addOrigin: "Add site",
      removeOrigin: "Remove {{origin}}",
      noOrigins: "No sites yet. Nothing can host this app until you add one.",
      originErrorWildcard: "Wildcards are not allowed. Add each site separately.",
      originErrorInvalid: "Enter a site address like https://portal.example.com, with no path.",
      views: "Views it may open",
      scopes: "What it may do",
      interactiveOff: "Changing data needs Interactive embeds on your plan. Until then, only viewing applies.",
      userCeiling: "People never get more than their own AssetWRX access.",
      identityTitle: "Sign-in",
      identityModeAssetwrx: "AssetWRX sign-in",
      identityModeSso: "Microsoft Entra SSO",
      identityModeHost: "Host-backed (enterprise)",
      identityHelp_assetwrx: "People sign in to AssetWRX inside the portal with their own AssetWRX account.",
      identityHelp_sso: "People sign in with their organization's Microsoft account, in the tenant below. Other accounts and other tenants are refused.",
      identityHelp_host: "The portal's server vouches for the person with an ID token signed by your identity provider, so there is no second sign-in. The person must be linked to this workspace, or added automatically.",
      idpEntra: "Microsoft Entra ID",
      idpOidc: "Other OpenID Connect provider",
      idpTenant: "Entra tenant ID",
      idpTenantHelp: "The directory (tenant) ID of the organization. Sign-ins from any other tenant are refused.",
      idpIssuer: "Issuer",
      idpIssuerHelp: "The web address that names your sign-in provider. Your IT team copies it from the provider's settings. It starts with https://.",
      idpAudience: "Audience",
      idpAudienceHelp: "The app ID your portal uses with the sign-in provider. Your IT team copies it from the provider's app registration.",
      jitEnable: "Add new people automatically",
      jitHelp: "Off: only people who are already linked or already members can open the portal view. On: people from the identity provider join this workspace the first time they arrive. An email address that already has an AssetWRX account is never linked automatically.",
      jitDomains: "Allowed email domains",
      jitDomainsHelp: "Separate with commas. Leave empty to allow anyone the identity provider signs in.",
      jitTeam: "Team for new people",
      jitRole: "New people join as members, never as admins.",
      sessionLifetime: "Session lifetime",
      hoursShort: "{{count}} h",
      identitySave: "Save sign-in settings",
      identityStats: "Open sessions: {{sessions}} · Linked people: {{identities}} · Refused (30 days): {{denied}}",
      lastDenied: "last refused {{date}}",
      linkedIdentities: "Linked people",
      noLinkedIdentities: "No one is linked yet.",
      linkedVia_admin: "Linked by an admin",
      linkedVia_jit: "Added automatically",
      linkedVia_sso: "Microsoft sign-in",
      unlink: "Unlink",
      unlinkTitle: "Unlink this person?",
      unlinkMsg: "Their embedded sessions end now, and the identity provider can no longer sign them in here until they are linked again.",
      linkSubject: "Identity provider user ID",
      linkSubjectHelp: "The person's ID in your sign-in provider (in Microsoft Entra, their Object ID on the user's page). Then choose the member below.",
      link: "Link",
      theme: "Appearance",
      themeAssetwrx: "AssetWRX",
      themeHost: "Match host",
      themeLight: "Light",
      themeDark: "Dark",
      viewWork: "Work",
      viewAssets: "Assets",
      viewAsset: "Asset",
      viewInspection: "Inspection",
      viewJob: "Job",
      viewRequest: "Request",
      viewInspectionReport: "Inspection report",
      viewJobReport: "Job report",
      created: "Created {{date}}",
      lastUsed: "Last used {{date}}",
      neverUsed: "Never used",
      delete: "Delete",
      deleteTitle: "Delete {{name}}?",
      deleteMsg: "Portals using it stop working straight away. This cannot be undone.",
      cancel: "Cancel",
      actionFailed: "That did not save. Try again.",
    },
    apiKeys: {
      create: 'Create API key',
      defaultName: 'API key',
      createFailed: 'Could not create the key. {{message}}',
      address: 'API address',
      howPowerBi: 'In Power BI choose Get Data → OData feed, enter {{url}}/v1/odata, then Basic: any user name and this key as the password.',
      howHeader: 'Send the key in the x-asset-inspector-key header on every request.',
      openGuide: 'Open the setup guide',
      done: 'Done',
      nameLabel: 'Name',
      createButton: 'Create key',
      manage: 'Rotate or revoke',
      hide: 'Hide',
    },
    serviceAccounts: {
      title: 'API keys',
      subtitle: 'Create a key for Power BI, Power Automate or your own system, then rotate or revoke it here. A key is shown once.',
      emptyTitle: 'No API keys yet',
      emptyDesc: 'Create a key with Create API key, or from any connection journey.',
      revokeTitle: 'Revoke this access?',
      revokeMsg: 'The service account and every key are revoked immediately. This cannot be undone.',
      lastUsed: 'Last used {{date}}',
      neverUsed: 'Never used',
      created: 'created {{date}}',
    },
    aiSettings: {
      title: 'AssetWRX AI (MCP)',
      subtitle: 'Control what approved AI assistants can do with AssetWRX. Every change an AI proposes still needs confirmation.',
      exposure: 'AI access',
      statusEnabled: 'Enabled',
      statusDisabled: 'Disabled',
      enable: 'Enable AI access',
      disable: 'Disable',
      endpointLabel: 'MCP endpoint',
      approvalsLoadFailed: "Could not load the AI requests waiting for approval.",
      ttlLabel: 'Proposal expiry',
      ttlHours_one: "{{count}} hour",
      ttlHours_other: "{{count}} hours",
      ttlHour: '1 hour',
      toolsTitle: 'Tools',
      toolsEmpty: 'No tools available.',
      writeAction: 'Can make changes (needs confirmation)',
      rowEnable: 'Enable',
      rowDisable: 'Disable',
      resourcesTitle: 'Resources',
      resourcesEmpty: 'No resources available.',
      activityTitle: 'Recent AI activity',
      activityEmpty: 'No AI activity yet.',
      actionFailed: 'Could not update. Try again.',
    },
    connectedPanel: {
      eyebrow: 'Connected assets',
      title: 'Connected event ingestion',
      subtitle:
        'Manage sources, review inbound traffic, resolve ambiguous matches, and add rules. Use the configuration wizard first, then the sections below.',
    },
    connectedConfigWizard: {
      eyebrow: 'Configuration',
      title: 'Set up connected ingestion',
      lead: 'This wizard walks you through creating a source, securing its token, copying the ingest URL, and understanding optional rules.',
      pillWelcome: 'Start',
      pillSource: 'Source',
      pillEndpoint: 'Ingest URL',
      pillRule: 'Rules',
      pillComplete: 'Done',
      welcomeTitle: 'What you are configuring',
      welcomeIntro: 'You will wire an external system (SCADA, gateway, script) to POST JSON events into this workspace.',
      welcomeStep1: 'Create a connected source (logical inbox).',
      welcomeStep2: 'Copy the one-time ingest token from the secure popup—same flow as API keys.',
      welcomeStep3: 'Copy the POST URL and a sample payload for your integration.',
      welcomeStep4: 'Optionally add a rule: when events match a pattern, run a clear action (draft, alert, or notify).',
      sourceTitle: 'Create a connected source',
      sourceLead: 'Give the source a friendly name your team will recognize. The internal key must be unique; leave it blank to auto-generate.',
      fieldSourceName: 'Display name',
      placeholderSourceName: 'e.g. North plant PLC',
      fieldSourceKey: 'Internal key (optional)',
      hintSourceKey: 'Letters, numbers, and hyphens only. Used in logs and metadata—not shown to senders.',
      placeholderSourceKey: 'e.g. north-plant-plc',
      createSourceCta: 'Create source & show token',
      creating: 'Creating…',
      defaultSourceName: 'Connected source {{n}}',
      endpointTitle: 'Send events to this URL',
      endpointLead: 'Your sender must use HTTPS POST with JSON. Prefer the per-source token in the x-connected-source-token header.',
      postUrlLabel: 'Your ingest URL',
      copyPostUrl: 'Copy POST line',
      copySampleJson: 'Copy sample JSON',
      endpointNoSource: 'Create a source in the previous step (or use New source above) to see your ingest URL here.',
      endpointHeaderHint: 'Required header when using the ingest token:',
      endpointBearerHint: 'If you use a workspace service account instead, send Authorization: Bearer <API key> with connected_* scopes.',
      openApiKeys: 'Open API keys & access',
      ruleStepTitle: 'Rules (optional)',
      ruleStepLead:
        'Rules watch incoming events after they are stored. When an event key matches your pattern, AssetWRX runs one action—for example publish to the automation outbox so recipes can react.',
      ruleStepHint: 'Use the rule builder below to choose “when” and “then” in plain language. New rules start paused so you can review before activating.',
      completeTitle: 'You are ready to integrate',
      completeBody: 'Scroll down to manage sources, inspect recent events, resolve unmatched payloads, and tune rules. Rotate the ingest token any time; each rotation shows the new secret once in the same popup.',
    },
    connectedIngestModal: {
      title: 'Ingest token (shown once)',
      leadCreate: 'Copy this token to a password manager or secret store. Send it as header x-connected-source-token on every POST to this source.',
      leadRotate: 'Your previous ingest token stopped working when you rotated. Copy the new token and update every sender before traffic resumes.',
      copiedTitle: 'Copied',
      copiedBody: 'Value copied to the clipboard.',
      missingTokenTitle: 'No token returned',
      missingTokenBody: 'The server did not return a new ingest token. Try again or check Edge Function logs.',
    },
    connectedRules: {
      builderTitle: 'Build a connected rule',
      builderSubtitle:
        'Rules answer: “When an event looks like this, do that.” Patterns use event keys (for example telemetry.temperature or connected.*). Actions run only after an event is stored; several actions require the event to already match an asset.',
      fieldRuleName: 'Rule name (optional)',
      placeholderRuleName: 'e.g. Notify when telemetry arrives',
      whenLabel: 'When incoming events match',
      whenHint: 'Choose how strictly to match the event key. Most teams start with “Any connected event” or a short prefix.',
      matchAll: 'Any connected event',
      matchPrefix: 'Prefix',
      matchCustom: 'Advanced pattern',
      placeholderPrefix: 'e.g. telemetry (becomes telemetry.*)',
      customHint: 'Power users: enter a full pattern such as connected.* or job.status_changed.',
      thenLabel: 'Then do this',
      actionTitle_outbox_publish: 'Publish to automation outbox',
      actionBody_outbox_publish:
        'Emits a workspace event other systems and automation recipes can consume—similar to a webhook fan-out inside AssetWRX.',
      actionTitle_asset_alert: 'Raise an asset alert',
      actionBody_asset_alert: 'Writes a visible activity entry on the matched asset. Optional custom title.',
      actionTitle_asset_reposition: 'Update the asset location',
      actionBody_asset_reposition: 'Applies a position the device reported. A mobile asset moves silently; anything expected to stay put raises a claim for its manager.',
      actionTitle_inspection_create: 'Create inspection draft',
      actionBody_inspection_create: 'Opens a draft inspection on the matched asset. Requires a checklist UUID.',
      actionTitle_job_create: 'Create job draft',
      actionBody_job_create: 'Opens a draft work item linked to the matched asset when the resolver found one.',
      fieldOutboxEventType: 'Outbox event type',
      fieldAlertTitle: 'Alert title (optional)',
      placeholderAlertTitle: 'Defaults to the event summary if empty',
      fieldChecklistTemplateId: 'Checklist id',
      hintChecklistTemplateId: 'UUID of an existing checklist in this workspace. The draft inspection uses this checklist.',
      placeholderUuid: '00000000-0000-0000-0000-000000000000',
      fieldJobTitle: 'Job title (optional)',
      placeholderJobTitle: 'Defaults to a title derived from the event',
      sourceScopeLabel: 'Apply this rule to',
      sourceScopeHint: 'All sources, or only events from one source below.',
      sourceAll: 'All sources',
      createRuleCta: 'Create rule (starts paused)',
      ruleCreated: 'Rule created',
      defaultRuleName: 'Rule for {{pattern}}',
      ruleDescriptionAuto: 'Created from the connected ingestion rule builder.',
      checklistRequiredTitle: 'Checklist required',
      checklistRequiredBody: 'Inspection drafts need a checklist UUID. Paste one from your workspace checklists, or pick a different action.',
    },
    connectedSections: {
      reload: 'Reload',
      newSource: 'New source',
      rotateToken: 'Rotate token',
      sourcesTitle: 'Sources',
      sourcesSubtitle: 'Each source has its own ingest URL and token lifecycle.',
      sourcesEmpty: 'No connected sources yet.',
      sourceActivity: 'Last received: {{received}} · Last event: {{last}}',
      never: 'Never',
      eventsTitle: 'Recent events',
      eventsSubtitle: 'Latest payloads accepted by the API (reprocess is safe when instructed by support).',
      eventsEmpty: 'No connected events yet.',
      noSummary: 'No assistant summary yet.',
      assetLabel: 'Asset',
      unresolved: 'unresolved',
      reprocess: 'Reprocess',
      reprocessed: 'Event reprocessed',
      unresolvedTitle: 'Unresolved queue',
      unresolvedSubtitle: 'Events that could not be matched to a single asset—resolve manually, then reprocess if needed.',
      unresolvedEmpty: 'No unresolved connected events.',
      resolveFirst: 'Resolve first',
      candidates_one: "{{count}} candidate asset",
      candidates_other: "{{count}} candidate assets",
      resolved: 'Unresolved event resolved',
      noCandidateTitle: 'No candidate available',
      noCandidateBody: 'This unresolved event has no stored candidate asset to apply automatically.',
      rulesListTitle: 'Saved rules',
      rulesListSubtitle: 'Activate a rule when you are satisfied with its pattern and action. Paused rules never run.',
      rulesEmpty: 'No connected rules yet.',
      pause: 'Pause',
      activate: 'Activate',
      noDescription: 'No description provided.',
      ruleActivated: 'Rule active',
      rulePaused: 'Rule paused',
      executionsTitle: 'Execution history',
      executionsSubtitle: 'Latest connected rule runs with audit status.',
      executionsEmpty: 'No connected rule executions yet.',
      attempt: 'attempt',
      executionEvent: 'Event {{id}} · {{at}}',
      alertActionTitle: 'Connected admin action failed',
      alertActionBody: 'Something went wrong. Please try again.',
      healthTitle: 'Integration health',
      healthSubtitle: 'Operational status, retry posture, and latest ingest outcomes.',
      healthLabel: 'Health',
      lastSuccessLbl: 'Last successful sync',
      lastFailedLbl: 'Last failed sync',
      logsLbl: 'Logs / history',
      logsVal: '{{e}} events · {{r}} runs',
      retryFailed: 'Retry latest failed event',
      copyPayload: 'Copy test payload',
      credsNote:
        'Credentials: source tokens are revealed once, then shown by prefix and last four only. Use service-account keys with connected_* scopes for bearer-token integrations.',
      needsAction: 'Action needed',
      needsReview: 'Review needed',
      healthyLbl: 'Healthy',
      notConfigured: 'Not configured',
      errPrefix: 'Error: {{m}}',
      seeSummary: 'See execution output summary.',
    },
    automationSubGuided: 'Guided',
    automationSubRuns: 'Run history',
    automationSubExpert: 'Expert editor',
    docsBarAutomationGuide: 'Automation guide',
    docsBarIntegrationsOverview: 'Webhooks & connections overview',
    docsBarBrowseApi: 'Open live API reference',
    docsBarApiHandbook: 'Full connection guide',
    docsBarOpenApiKeys: 'API keys & service accounts',
    docsBarConnectedPreview: 'Connected preview',
    automationsKeysCalloutTitle: 'Service accounts and API keys are not created here',
    automationsKeysCalloutBody:
      'Use the API keys & access tab to create service accounts, issue API keys, verify the gateway, and copy endpoints. This tab is for event-trigger recipes and run history only.',
    automationsKeysCalloutCta: 'Open API keys & access',
    apiExplorerLead:
      'Read-only reference for the public API. “Try it” is disabled inside this viewer so your credentials are not exposed to arbitrary origins (CORS). Use API keys & access → Verify connection with your session, or test with a service account key from the same screen.',
    apiExplorerServerDescription: 'AssetWRX workspace API',
    apiExplorerGoVerify: 'Open API keys & access to verify your connection',
    apiExplorerBack: 'Back',
    apiExplorerPhoneTitle: 'Best explored on a larger screen',
    apiExplorerPhoneBody:
      'The interactive API reference is built for a tablet or desktop. Open this page there to browse endpoints and models. You can still manage API keys above and copy your base URL below.',
    apiExplorerBaseUrlLabel: 'Base URL',
    apiExplorerCovers: 'Covers assets and places, sites, checklists, inspections and their schedules, jobs, maintenance plans and programmes, contacts, teams, insights, files, webhooks, automation, connected devices, Power BI and AI agents. Sites, checklists, schedules, maintenance and teams are read-only.',
    apiExplorerSectionNeeds: 'Plan switch: {{names}}.',
    apiExplorerSectionOff: 'Not in your plan: {{names}} is switched off for this workspace.',
    apiExplorerNotInPlan: 'Not in your plan, so these calls are refused: {{sections}}.',
    handbookTitleAutomation: 'Automation guide (in app)',
    handbookTitleIntegrations: 'API & connections guide (in app)',
    handbookLead: 'This content is bundled with the app from the canonical Markdown in the product repository.',
    handbookOpenHosted: 'Open hosted copy',
    handbookCopyMarkdown: 'Copy Markdown',
    handbookCopyDoneTitle: 'Copied',
    handbookCopyDoneBody: 'The guide Markdown was copied to your clipboard.',
    handbookCopyFailedTitle: 'Copy failed',
    handbookCopyFailedBody: 'Could not copy to the clipboard on this device.',
    handbookOpenFailedTitle: 'Could not open link',
    handbookOpenFailedBody: 'Check the hosted documentation URL in your workspace environment settings.',
    docsFallbackTitle: 'Documentation link',
    docsFallbackAutomationIntro:
      'Hosted documentation is not configured yet. You can copy these internal reference paths for your records or to share with whoever manages integrations.',
    docsFallbackApiIntro:
      'Hosted documentation is not configured yet. You can copy these internal reference paths for your records or to share with whoever manages integrations.',
    docsFallbackCopy: 'Copy reference paths',
    docsFallbackClose: 'Close',
    docsPathAutomation: 'Automation guide (internal reference)',
    docsPathApi: 'API & integrations (internal reference)',
    docsPathOpenApiYaml: 'OpenAPI contract (internal reference)',
    showAdvancedDetails: 'Show advanced details',
    hideAdvancedDetails: 'Hide advanced details',
    loadingContracts: 'Loading integration contracts…',
    retryLoad: 'Retry load',
    navSectionMain: 'Modules',
    navSectionAutomation: 'Event trigger views',
    guidedBadge: 'Guided',
    recipeListTitle: 'Recipes in this workspace',
    recipeListSubtitle: 'Activate, pause, duplicate, archive, run with optional JSON, rotate inbound tokens, and retry from history.',
    recipeNoActions: 'no actions',
    recipeListEmpty: 'No recipes yet.',
    recipePause: 'Pause',
    recipePaused: 'Recipe paused',
    recipeActivate: 'Activate',
    recipeActive: 'Recipe active',
    recipeManualRun: 'Manual run',
    recipeDuplicate: 'Duplicate',
    recipeDuplicated: 'Recipe duplicated',
    recipeRotateToken: 'Rotate token',
    recipeTokenRotated: 'Webhook token rotated',
    recipeArchive: 'Archive',
    recipeArchived: 'Recipe archived',
    guidedWizard: {
      title: 'Guided automation',
      subtitle:
        'Pick a template, fill a few fields, then create a server-backed draft. Advanced recipe editing stays under Event Triggers → Expert editor.',
      publicApiLead: 'All runs execute in your workspace on the public API; nothing is simulated in the app.',
      apisShortcutLabel: 'Create or view service accounts and API keys',
      apisShortcutA11y: 'Open API keys and access to manage service accounts and API keys',
      pillType: 'Type',
      pillBasics: 'Basics',
      pillReview: 'Review',
      pillArtifacts: 'Test & save',
      pillDone: 'Done',
      next: 'Next',
      back: 'Back',
      categoryWorkflow: 'Everyday workflows',
      categoryInspection: 'Inspections',
      categoryJob: 'Jobs',
      categoryAssetSync: 'Asset sync',
      categoryInboundWebhook: 'Inbound webhooks',
      categoryScheduled: 'Scheduled',
      categoryOutbound: 'Testing & notifications',
      fieldName: 'Name',
      placeholderName: 'Short internal name',
      fieldDescription: 'Description (optional)',
      placeholderDescription: 'Who uses this and what system receives it',
      fieldForwardUrl: 'Forward to HTTPS URL',
      fieldDestinationUrl: 'Destination HTTPS URL',
      fieldSigningSecret: 'Signing secret (optional)',
      placeholderSigningSecret: 'Leave blank if your receiver does not verify HMAC',
      fieldFilterStatus: 'Only when inspection status equals (optional)',
      placeholderFilterStatus: 'e.g. completed — leave blank to send on every update',
      fieldAssetEvent: 'Asset event',
      fieldIntervalMinutes: 'Interval (minutes)',
      fieldJobIdPath: 'Job id field in JSON body',
      fieldStatusPath: 'Status field in JSON body',
      reviewWhen: 'When: ',
      reviewDo: 'Do: ',
      reviewNeedFix: 'Fix any errors in Basics to see the compiled recipe.',
      artifactsLead:
        'Copy contract YAML or sample JSON for partners. When you are ready, create a draft — then activate the recipe and use Manual run with JSON from the list below.',
      copyYaml: 'Copy contract YAML',
      manualRunHelp: 'Manual run help',
      copySampleEvent: 'Copy sample domain event JSON',
      copyManualInput: 'Copy manual run sample input',
      saving: 'Saving…',
      createDraftContinue: 'Create draft and continue',
      draftCreatedAlert: 'Automation draft created',
      turnedOnAlert: 'Automation turned on',
      turnOn: 'Turn on',
      saveDraft: 'Save as draft',
      copiedTitle: 'Copied',
      copiedYamlBody: 'Contract YAML copied to clipboard.',
      copiedEventBody: 'Sample event JSON copied.',
      copiedManualBody: 'Use this body as input when calling manual runs after activation.',
      successTitle: 'Draft saved',
      successBody: 'Your recipe appears in the list below. Activate it when you are ready, then use Manual run to test with JSON.',
      successBodyActive: 'It is on. Every run shows in this automation’s history.',
      createAnother: 'Create another',
      alertNeedTypeTitle: 'Choose a type',
      alertNeedTypeBody: 'Select an automation checklist to continue.',
      alertInvalidTitle: 'Check fields',
      alertInvalidBody: 'Fill required fields to continue.',
      manualHarnessTitle: 'Manual harness',
      manualHarnessBodyGeneric:
        'Create a “Manual test webhook” draft, activate it, then use Manual run on the recipe row with the sample JSON.',
      manualHarnessCreateFirstTitle: 'Create first',
      manualHarnessCreateFirstBody:
        'Save this automation as a draft from “Create draft and continue”, then activate it and use “Manual run” on the recipe row with the sample JSON.',
    },
    manualRunModal: {
      title: 'Manual run',
      inputLabel: 'Optional JSON input (object)',
      run: 'Queue run',
      cancel: 'Cancel',
      errorInvalidJson: 'Enter valid JSON or leave empty for {}.',
      errorNotObject: 'Input must be a JSON object (not an array).',
      successTitle: 'Manual run queued',
      successBody: 'Run id: {{id}}\nStatus: {{status}}',
      goToRuns: 'Open run history',
    },
    accessWizard: {
      pageTitle: 'API keys & access',
      pageSubtitle:
        'Overview, verify the gateway, manage keys, create a new key, review inbound automations, then copy the REST base URL and paths. Nothing here bypasses your workspace security.',
      pillPurpose: 'Overview',
      pillVerify: 'Verify',
      pillAccounts: 'Existing keys',
      pillCreate: 'New key',
      pillInbound: 'Inbound',
      pillEndpoints: 'Endpoints',
      purposeTitle: 'What you can connect',
      purposeBody:
        'REST API keys let trusted systems read and write workspace data. Outbound platform webhooks are configured separately in the connection guide. Recipe inbound URLs are for automation triggers.',
      openHandbook: 'Open full connection guide',
      verifyTitle: 'Verify workspace API (session)',
      verifyLead: 'Confirms the same gateway the app uses for integration management is reachable with your current sign-in.',
      verifyAppLoginVsApiKeyTitle: 'App sign-in vs API keys',
      verifyAppLoginVsApiKeyBody:
        'You log into this app with your user account (the same session as the rest of AssetWRX). API keys are only for other systems and scripts calling the workspace REST API—they are not a replacement for signing in here.',
      verifyConnection: 'Verify connection',
      verifying: 'Verifying…',
      sessionVerifyOk: 'Reachable. Workspace {{workspaceId}} · principal: {{principal}}',
      accountsListTitle: 'Existing service accounts',
      accountsListLead: 'Keys are SHA-256 hashed at rest; plaintext is shown only once on create or rotate. Refresh the list after creating a key on another device.',
      accountsListSecretCalloutTitle: 'Why you do not see the full key in this list',
      accountsListSecretCalloutBody:
        'Only a hash is stored server-side. The full secret appears once in the popup when you create or rotate—copy it to a password manager then. Below you see account names and scopes only. If you closed the popup without saving, use Rotate key to issue a new secret.',
      accountsAdminErrorHint:
        'Only workspace administrators can list or create service accounts and API keys. Sign in with an admin account, or ask an owner to grant admin on your workspace.',
      refreshList: 'Refresh list',
      refreshLoading: 'Loading…',
      lastUsed: 'Last used {{when}}',
      neverUsed: 'Not used yet',
      rotatedOn: 'Key rotated {{when}}',
      revokedOn: 'Revoked {{when}}',
      rotateKey: 'Rotate key',
      revoke: 'Revoke',
      revoked: 'Revoked',
      noAccounts: 'No service accounts yet.',
      createTitle: 'Create service account',
      createLead: 'Choose a name, optional description, scopes, and optional key expiry. You will see the full key once — store it in a vault.',
      endpointsTitle: 'REST gateway & paths',
      endpointsLead:
        'All versioned REST calls go through this base URL. Append paths from the contract (for example /v1/assets). Automation inbound URLs are separate and listed on the Inbound step.',
      endpointsBaseLabel: 'Gateway base URL',
      endpointsCopyBase: 'Copy base URL',
      endpointsCopiedTitle: 'Copied',
      endpointsCopiedBody: 'Gateway base URL copied to the clipboard.',
      endpointsExamplesTitle: 'Examples (relative to base)',
      endpointsExampleStatus: 'GET /v1/status — workspace API health (requires status:read for API keys)',
      endpointsExampleAssets: 'GET /v1/assets — list assets (requires assets:read)',
      endpointsExampleInbound: 'Inbound automations use per-recipe HTTPS URLs from the Inbound step, not this base URL.',
      endpointsExampleDocs: 'Every path, query parameter, and body shape is in the live OpenAPI reference.',
      endpointsAuthHint:
        'From other systems: send header apikey: <your AssetWRX publishable key> and Authorization: Bearer <your service account API key>. This app uses your sign-in session instead.',
      endpointsOpenReference: 'Open live API reference',
      fieldName: 'Name',
      fieldDescription: 'Description (optional)',
      fieldExpiry: 'First key expires at (optional ISO date)',
      placeholderName: 'ERP nightly sync',
      placeholderDescription: 'Internal note',
      saving: 'Saving…',
      createShowKey: 'Create & show key',
      inboundTitle: 'Inbound recipe endpoints',
      inboundLead: 'Shown for recipes that use the inbound webhook trigger. URLs and secrets appear on the recipe after activation.',
      inboundToken: 'Token {{prefix}}…{{last}}',
      inboundEmpty: 'Create a recipe with the inbound webhook trigger to generate a tokenized endpoint.',
      keyVerifyOk: 'Test request with this key succeeded (GET /v1/status).',
      keyVerifyFail: 'Could not verify key with GET /v1/status: {{message}}',
      keyVerifySkipped: 'Add the “Workspace status” (status:read) scope to verify new keys automatically next time.',
      keyRevealModalTitle: 'Your new API key',
      keyRevealModalLead: 'Copy this secret and store it in a password manager. You cannot view the full key again in this list.',
      keyRevealCopy: 'Copy key',
      keyRevealSaved: 'I have saved it',
      keyRevealMissingFromServer: 'The server did not return a key. Try again or check Edge Function logs.',
      keyRevealCopiedTitle: 'Copied',
      keyRevealCopiedBody: 'API key copied to the clipboard.',
    },
    mcpWizard: {
      pageTitle: 'Workspace MCP servers',
      pageSubtitle:
        'Connect approved remote MCP servers over HTTPS, store secrets encrypted, run discovery from the backend, then choose which tools and resources the assistant may propose.',
      flowLabel: 'Guided setup',
      pillIntro: 'Overview',
      pillServer: 'Server',
      pillCredentials: 'Secrets',
      pillVerify: 'Test & discover',
      pillCatalog: 'Allow list',
      pillHistory: 'History',
      loading: 'Loading MCP configuration…',
      loadError: 'Could not load MCP configuration.',
      detailLoadError: 'Could not load tools and resources for this server.',
      introTitle: 'What you are setting up',
      introLead:
        'Model Context Protocol (MCP) lets the operational assistant call external tools and read external resources after you confirm each proposal. This workspace keeps a strict allow list.',
      introWhatTitle: 'Version 1 constraints',
      introWhatBody:
        'Only remote HTTP JSON-RPC endpoints are supported. Credentials are encrypted server-side; the app never receives plaintext secrets after save. Discovery and calls always run through the public API Edge Function.',
      introStepsTitle: 'Follow these steps in order',
      introStep1: 'Register the server name and HTTPS base URL your vendor documented.',
      introStep2: 'Save credentials if the endpoint requires a bearer token, API key header, or custom header.',
      introStep3: 'Test the connection, then run discovery so tools and resources appear in the catalog.',
      introStep4: 'Turn on only the tools and resources this workspace should ever invoke.',
      introStep5: 'Optionally enable “Assistant” per row so the planner can propose that tool or resource (you still confirm before it runs).',
      introStep6: 'Review invocation history for audits and troubleshooting.',
      serverListTitle: 'Pick or add a server',
      serverListLead: 'Select a card to edit it, or use “Add MCP server” for a new row, then save below.',
      serverCardCounts: 'Tools: {{tools}} · Resources: {{resources}}',
      addServer: 'Add MCP server',
      serverFormTitle: 'Server details',
      serverFormLead:
        'Paste the exact MCP endpoint URL from your vendor. It must use HTTPS — use the example format below if you are unsure.',
      fieldName: 'Name',
      fieldDescription: 'Description (optional)',
      fieldBaseUrl: 'Base URL (HTTPS)',
      fieldBaseUrlPlaceholder: 'https://mcp.example.com/v1',
      fieldBaseUrlHint:
        'Must start with https://. Use the full path your MCP host documents (often /mcp, /sse, or /v1). HTTP and bare hostnames are not supported.',
      alertBaseUrlHttpsTitle: 'HTTPS URL required',
      alertBaseUrlHttpsBody:
        'The MCP base URL must start with https://. Example: https://mcp.example.com/v1',
      invalidBaseUrlFormat:
        'Enter a full URL including https://, for example https://mcp.example.com/v1',
      fieldTimeoutMs: 'Timeout (ms)',
      fieldMaxPayload: 'Max payload bytes',
      fieldHeaderName: 'Header name',
      fieldSecret: 'Secret',
      secretPlaceholderNew: 'Enter the secret once to encrypt it',
      secretPlaceholderRotate: 'Enter a new secret to rotate the stored value',
      saving: 'Saving…',
      updateServer: 'Update server',
      createServer: 'Create server',
      serverSavedTitle: 'MCP server saved',
      serverSavedBody: '{{name}} is stored. Continue to Secrets when the endpoint needs authentication.',
      serverSaveFailedTitle: 'Save failed',
      serverSaveFailed: 'Could not save MCP server.',
      credentialsTitle: 'Encrypted credentials',
      credentialsLead: 'Choose how the backend authenticates to the MCP server. Use “none” only for hosts that do not require a secret.',
      credentialsNeedServer: 'Save a server on the previous step before adding credentials.',
      credentialStored: 'Stored: {{type}} {{prefix}}…{{last}}',
      saveCredentials: 'Save credentials',
      credentialsSavedTitle: 'Credentials updated',
      credentialsSavedBody: 'Secrets are encrypted at rest. Only masked metadata is returned to the app afterwards.',
      credentialsSaveFailedTitle: 'Credential update failed',
      credentialsSaveFailed: 'Could not save credentials.',
      noSecretStored: 'No secret stored',
      verifyTitle: 'Test connection and discover',
      verifyLead: 'Test performs a lightweight initialize handshake. Discovery lists tools and resources so you can approve them.',
      verifyOrderTitle: 'Recommended order',
      verifyOrderBody: 'Run Test connection first. If it succeeds, run Discover metadata, then move to Allow list to enable entries.',
      verifyNeedServer: 'Save a server first, then return here.',
      testConnection: 'Test connection',
      discoverMetadata: 'Discover metadata',
      testOkTitle: 'Connection test passed',
      testOkBody: 'Completed in {{ms}} ms.',
      discoverOkTitle: 'Discovery complete',
      discoverOkBody: 'Found {{tools}} tools and {{resources}} resources.',
      testFailedTitle: 'Connection test failed',
      discoverFailedTitle: 'Discovery failed',
      actionFailedGeneric: 'Could not complete that operation.',
      catalogTitle: 'Allow list for tools and resources',
      catalogLead:
        'Workspace enables/disables whether the backend may call an entry at all. Assistant toggles add planner visibility on top of that.',
      catalogNeedServer: 'Save a server and run discovery before managing the catalog.',
      toolsHeading: 'Tools',
      resourcesHeading: 'Resources',
      noTools: 'No tools discovered yet. Run Discover metadata on the previous step.',
      noResources: 'No resources discovered yet. Run Discover metadata on the previous step.',
      workspaceOn: 'Workspace on',
      workspaceOff: 'Workspace off',
      assistantOn: 'Assistant on',
      assistantOff: 'Assistant off',
      historyTitle: 'Invocation history',
      historyLead: 'Each call records target, timing, status, and sanitized payload previews.',
      noInvocations: 'No MCP invocations recorded yet.',
      invocationMeta: 'Duration {{ms}} ms · {{when}}',
      maskedLine: 'Latest credential mask: {{mask}}',
      alertNeedServerTitle: 'Save a server first',
      alertNeedServerBody: 'Create or select a server, fill in the required fields, and tap Create server or Update server before moving on.',
      alertServerFieldsTitle: 'Check required fields',
      alertServerFieldsBody: 'Enter a display name and HTTPS base URL before continuing.',
      alertNoServerTitle: 'No server selected',
      alertNoServerBody: 'Select or create a server before saving credentials.',
      toolUpdateFailedTitle: 'Tool update failed',
      toolUpdateFailed: 'Could not update MCP tool.',
      resourceUpdateFailedTitle: 'Resource update failed',
      resourceUpdateFailed: 'Could not update MCP resource.',
    },
    editor: {
      saved: "Automation updated",
      saveFailed: "Could not save",
      title: "Edit automation",
      notGuidedTitle: "Not a guided automation",
      notGuidedDesc: "This one was built in the advanced builder. Edit it there.",
      save: "Save",
    },
    guidedForm: {
      severityLabel: "When it finds",
      severityAny: "Any issue",
      severityUrgent: "Urgent issues only",
      checklistLabel: "Only for this checklist",
      anyChecklist: "Any checklist",
      assignLabel: "Assign the job to",
      nobodyYet: "Nobody yet",
      urgencyLabel: "Urgency of the renewal job",
      urgencyDefault: "Normal",
      urgencyHigh: "High",
      urgencyUrgent: "Urgent",
      thresholdLabel: "Jobs worth this or more ({{currency}})",
      approverLabel: "Who signs them off",
      choosePerson: "Choose a person",
      daysLabel: "Unanswered for",
      daysOption_one: "{{count}} day",
      daysOption_other: "{{count}} days",
      assetCreated: "Created",
      assetUpdated: "Updated",
      assetDeleted: "Deleted",
      titlePathLabel: "Job title comes from this field in the JSON",
      unknownChoice: "No longer in the workspace",
      wholeTeam: "Whole team",
      notifyLabel: "Tell",
      nobody: "Nobody",
      choosePersonOrTeam: "Choose a person or team",
      close: "Close",
      search: "Search…",
      noMatch: "Nothing matches.",
    },
  },
  connectedAssets: {
    title: 'Connected assets',
    lead: 'IoT connectors and live asset telemetry will appear here. This area is reserved for future workspace features.',
    backToIntegrations: 'Back to automations',
    moreTitle: 'Scope and roadmap',
    moreSummary: 'Connectors, device state, and automation hooks.',
    moreBody:
      'Connected assets will surface live readings, last-seen status, and links back to inspections and jobs when your workspace enables integrations. Use automations to provision connectors and manage data access.',
    showMore: 'Show more',
    showLess: 'Show less',
  },
  apiAccess: {
    catalogScopesLabel: 'API access areas',
    noScopes: 'No access areas selected',
    fullAccessChip: 'Full API access',
    scopesSectionTitle: 'What this key can use',
    scopesSectionHint:
      'Pick a starter kit for common tools, then fine-tune with the checkboxes. Only turn on what your integration needs.',
    presetsLabel: 'Starter kits',
    preset_starter_title: 'Reports & lists',
    preset_starter_subtitle: 'Read workspace status, assets, inspections, and jobs — good for dashboards and read-only sync.',
    preset_field_title: 'Field operations',
    preset_field_subtitle:
      'Adds creating and updating assets, contacts, inspections, and jobs — typical for mobile or crew tools.',
    preset_automation_title: 'Automations & events',
    preset_automation_subtitle:
      'Includes recipes, automation catalog, and reading events — for Zapier-style workflows and webhooks.',
    preset_full_title: 'Everything (admin)',
    preset_full_subtitle: 'Full API power including GraphQL and managing other keys. Use only for trusted server software.',
    preset_read_only_title: 'Read only',
    preset_read_only_subtitle:
      'View workspace status, assets, contacts, inspections, jobs, and the event feed. Nothing can be changed.',
    preset_power_bi_title: 'Power BI',
    preset_power_bi_subtitle: 'Read assets, inspections and jobs through the OData feed. Nothing can be changed.',
    preset_power_automate_title: 'Power Automate',
    preset_power_automate_subtitle: 'What the Power Automate connector needs: read assets; read and create jobs and inspections; start flows from events.',
    preset_asset_operations_title: 'Asset operations',
    preset_asset_operations_subtitle:
      'Create and update assets and contacts, with read access to templates — for keeping an asset register in sync.',
    preset_inspections_title: 'Inspections',
    preset_inspections_subtitle:
      'Create and update inspections, with read access to assets, jobs, and templates — for inspection tools.',
    preset_wrx_operations_title: 'WRX operations',
    preset_wrx_operations_subtitle:
      'Full read and write across assets, contacts, inspections, and jobs (WRX) plus the event feed — for operational systems.',
    preset_full_integration_title: 'Full integration',
    preset_full_integration_subtitle:
      'Complete API access including GraphQL and key management. Use only for trusted server software.',
    preset_custom_access_title: 'Custom',
    preset_custom_access_subtitle: 'Choose exactly which access areas this connection needs.',
    preset_ai_read_title: 'Read asset information',
    preset_ai_read_subtitle:
      'Let the AI agent read assets, contacts, inspections, and jobs. It cannot make changes.',
    preset_ai_inspection_title: 'Inspection assistant',
    preset_ai_inspection_subtitle:
      'Let the AI agent read assets and templates and create or update inspections.',
    preset_ai_wrx_title: 'WRX assistant',
    preset_ai_wrx_subtitle: 'Let the AI agent read and update assets, contacts, inspections, and jobs (WRX).',
    preset_ai_operations_title: 'Operations assistant',
    preset_ai_operations_subtitle:
      'Full operational access for the AI agent, including automation and connected-event context.',
    preset_custom_ai_title: 'Custom',
    preset_custom_ai_subtitle: 'Choose exactly which tools and information this AI connection can use.',
    group_overview: 'Overview & assistant',
    group_records: 'Assets, contacts, inspections & jobs',
    group_events: 'Webhooks & events',
    group_automation: 'Automation builder',
    group_connected: 'Connected sources, events & rules',
    group_advanced: 'Advanced & key management',
    scope_status_read: 'Workspace status',
    scope_dashboard_read: 'Dashboard data',
    scope_dashboards_read: 'Saved dashboards',
    scope_assistant_context_read: 'Assistant context (read)',
    scope_assets_read: 'View assets',
    scope_assets_write: 'Create & edit assets',
    scope_contacts_read: 'View contacts',
    scope_contacts_write: 'Create & edit contacts',
    scope_inspections_read: 'View inspections',
    scope_inspections_write: 'Create & edit inspections',
    scope_jobs_read: 'View jobs',
    scope_jobs_write: 'Create & edit jobs',
    scope_templates_read: 'View checklists',
    scope_templates_write: 'Create & edit checklists',
    scope_mcp_read: 'View AI (MCP) settings',
    scope_mcp_write: 'Manage AI (MCP) settings',
    scope_mcp_invoke: 'Use AI (MCP) tools',
    scope_connected_sources_read: 'View connected sources',
    scope_connected_sources_write: 'Manage connected sources',
    scope_connected_events_read: 'View connected events',
    scope_connected_events_write: 'Send connected events',
    scope_connected_rules_read: 'View connected rules',
    scope_connected_rules_write: 'Manage connected rules',
    scope_webhooks_read: 'View outbound webhooks',
    scope_webhooks_write: 'Manage outbound webhooks',
    scope_events_read: 'Read event feed',
    scope_graphql_read: 'GraphQL (read)',
    scope_graphql_write: 'GraphQL (write)',
    scope_service_accounts_read: 'View API keys & service accounts',
    scope_service_accounts_write: 'Manage API keys & service accounts',
    scope_automation_catalog_read: 'View automation catalog',
    scope_automation_recipes_read: 'View recipes',
    scope_automation_recipes_write: 'Create & edit recipes',
    scope_automation_runs_read: 'View recipe runs',
    scope_automation_actions_write: 'Run automation actions',
    alertNameTitle: 'Name required',
    alertNameBody: 'Enter a short name so your team knows what this integration is for.',
    alertScopesTitle: 'Pick at least one area',
    alertScopesBody: 'Choose a starter kit or tick one or more access areas.',
    alertExpiryTitle: 'Check the expiry date',
    alertExpiryBody: 'Use a valid date and time, or leave expiry blank.',
    alertStoreKeyTitle: 'Copy your API key now',
    alertStoreKeyBody:
      'This is the only time the full key is shown. Store it in a password manager or vault.\n\n{{key}}',
  },
  defaults: {
    memberNotice: "Only a workspace admin can change the workspace language and time zone. Your own are in Preferences.",
    saveFailedBody: "That change did not save. Check your connection and try again.",
    saveFailedTitle: "Not saved",
    currencyHint: "Used for costs you add. It is yours, not the workspace's; a team can set its own.",
    regionalSummary: 'Regional defaults',
    regionalBody:
      'Workspace defaults apply when a team member leaves language or timezone unset on their profile. Personal settings always override.',
    workspaceDefaultLanguage: 'Workspace default language',
    workspaceDefaultTimezone: 'Workspace default timezone',
    effectiveLanguage: 'Your effective language',
    effectiveTimezone: 'Your effective timezone',
    notSet: 'Not set',
    openOrganization: 'Edit in Organization profile',
    loading: 'Loading…',
    orgHint:
      'Defaults are edited in Organization profile. They use the same supported lists as personal language and timezone settings.',
    categorySubtitle: 'Defaults for your workspace. Used for inspections and jobs; teams can override these.',
    shareMethodEmail: 'Email',
    languageOptionA11y: 'Workspace language {{label}}',
    timezoneOptionA11y: 'Workspace default timezone',
    currencyLabel: "Your currency",
    currencyOptionA11y: "Currency {{code}}",
    shareMethodLabel: 'Communication (share method)',
    shareMethodOptionA11y: 'Default share method {{label}}',
    teamOverridesA11y: 'Open team settings and overrides',
    teamOverridesLink: 'Team settings & overrides',
    searchTimezone: 'Search timezone',
  },
  organization: {
    defaultLanguageLabel: 'Default language',
    timezoneLabel: 'Default timezone',
    notSet: 'Not set',
    languageHelper:
      'Used when a team member leaves personal language unset: then device language if supported, then English (US).',
    timezoneHelper:
      'Used when a team member leaves personal timezone unset: then device timezone, then UTC.',
  },
  assetTypes: {
    headerSubtitle: 'Your own kinds of asset and place, and the details each asks for',
    intro: 'Add the kinds of asset your workspace looks after, such as a chiller, a hotel room or a lift, and the details people fill in for each. Every asset of that type asks for the same details.',
    add: 'Add asset type',
    addTitle: 'New asset type',
    editTitle: 'Edit asset type',
    nameLabel: 'Name',
    namePlaceholder: 'For example Chiller or Guest room',
    nameRequired: 'Give the type a name',
    kindLabel: 'It is a',
    kindLocked_one: 'Used by {{count}} asset, so its kind stays the same.',
    kindLocked_other: 'Used by {{count}} assets, so its kind stays the same.',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Optional. What this type covers',
    fieldsLabel: 'Details to fill in',
    fieldsHint: 'Each asset of this type shows these on its detail page and in the create form.',
    fieldLabel: 'Detail name',
    fieldPlaceholder: 'For example Refrigerant or Number of beds',
    fieldKinds: {
      text: 'Text',
      number: 'Number',
      date: 'Date',
      choice: 'Pick from a list',
      yes_no: 'Yes or no',
    },
    optionsLabel: 'Choices',
    optionsPlaceholder: 'Separate with commas, for example R410A, R32, R134a',
    optionsRequired: 'Add at least one choice',
    unitLabel: 'Unit',
    unitPlaceholder: 'Optional, for example kW',
    requiredLabel: 'Must be filled in',
    removeField: 'Remove detail',
    addField: 'Add detail',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'Asset type saved',
    saveFailedTitle: 'Couldn\'t save the asset type',
    saveFailedBody: 'Check your connection and try again.',
    fieldCount_one: '{{count}} detail',
    fieldCount_other: '{{count}} details',
    usedBy_one: 'used by {{count}} asset',
    usedBy_other: 'used by {{count}} assets',
    archived: 'Archived',
    edit: 'Edit',
    archive: 'Archive',
    restore: 'Restore',
    showArchived_one: 'Show {{count}} archived type',
    showArchived_other: 'Show {{count}} archived types',
    hideArchived: 'Hide archived types',
    emptyTitle: 'No asset types of your own yet',
    emptyBodyAdmin: 'Add one to give a kind of asset its own details.',
    emptyBody: 'An owner or admin can add asset types for the workspace.',
    archiveConfirmTitle: 'Archive this asset type?',
    archiveConfirmBody: 'Assets that use it keep it and their details. It stops showing when people add new assets. You can restore it at any time.',
  },
  industryPacks: {
    later: "Later",
    onboardingFailedBody: "The ready-made checklists for your trade did not all arrive. Tap Try again to open Industry packs and add them.",
    onboardingFailedTitle: "Some checklists were not added",
    openTemplates: "Open checklists",
    perAssetNote: "Install pack adds the checklists. The maintenance plans and what to prove are suggested on each matching asset, for you to accept there.",
    title: 'Industry packs',
    headerSubtitle: 'Starter asset types, checklists and plans for your industry',
    subtitle: 'A curated starting point for what you manage. Add what is useful, change anything, remove what is not.',
    disclaimer: 'Suggestions to get you started, not legal advice. Check what applies where you operate.',
    installed: 'Installed',
    notInstalled: 'Not installed',
    installedCount_one: '{{installed}} of {{count}} checklist',
    installedCount_other: '{{installed}} of {{count}} checklists',
    newAvailable_one: '{{count}} new checklist available',
    newAvailable_other: '{{count}} new checklists available',
    install: 'Install pack',
    installing: 'Installing…',
    addRecommended: 'Add recommended checklists',
    upToDate: 'Everything from this pack is already here.',
    remove: 'Remove pack',
    removeConfirmTitle: 'Remove this pack?',
    removeConfirmBody: 'Checklists you have edited stay. Only untouched pack checklists are removed, and the sample asset goes when the last pack does.',
    removeConfirmAction: 'Remove',
    removedToast_one: '{{count}} checklist removed.',
    removedToast_other: '{{count}} checklists removed.',
    removedSampleNote: 'The sample asset was removed too.',
    keptNote_one: '{{count}} checklist kept because you edited it.',
    keptNote_other: '{{count}} checklists kept because you edited them.',
    installedToast: "Checklists added. Find them in Checklists.",
    partialToast: 'Some items could not be added. Try again to fill the gaps.',
    retry: 'Try again',
    sections: {
      assetTypes: 'What you can add',
      templates: 'Checklists',
      maintenance: 'Maintenance',
      compliance: 'What to prove',
    },
    suggestions: {
      title: 'From your industry pack',
      body: 'Suggested for this kind of asset. Nothing is added until you choose it.',
      addPlan: 'Add plan',
      planAdded: 'Added',
      declare: 'Track this',
      declared: 'Being tracked',
      empty: 'Nothing left to suggest for this asset.',
    },
    packs: {
      property: {
        name: 'Property',
        description: 'Homes, flats and commercial units — condition, move-in and move-out, fire safety and the certificates that go with them.',
      },
      fleet: {
        name: 'Fleet',
        description: 'Cars, vans, trucks and trailers — daily checks, damage, handover and servicing by date or distance.',
      },
      equipment: {
        name: 'Equipment',
        description: 'Machines, tools and plant — pre-use checks, condition, servicing by running hours and calibration evidence.',
      },
      facilities: {
        name: 'Facilities',
        description: 'Buildings and their plant — planned maintenance, safety inspections, plant rooms and statutory evidence.',
      },
    },
  },
  automationDescribe: {
    chosenPerson: "the chosen person",
    chosenTeam: "the chosen team",
    chosenChecklist: "the chosen checklist",
    chosenApprover: "the chosen approver",
    personAndTeam: "{{user}} and {{team}}",
    theThreshold: "the threshold",
    yourUrl: "your URL",
    severityUrgent: "an urgent issue",
    severityAny: "any issue",
    templateClause: " using “{{name}}”",
    assignedClause: " assigned to {{name}}",
    notifyClause: " and notify {{who}}",
    statusClause: " to “{{status}}”",
    failedFollowUp: "When an inspection finds {{severity}}{{template}}, AssetWRX will create a follow-up job{{assigned}}{{notify}}.",
    renewalWork: "When a certificate or document reaches its reminder date, AssetWRX will create a renewal job on the asset{{notify}}.",
    highCostApproval: "When a job worth {{amount}} or more is created, AssetWRX will ask {{approver}} to sign it off.",
    unansweredChase_one: "When a contractor hasn't answered an invitation or quote request for {{count}} day, AssetWRX will notify {{who}}, and again each week until it's answered.",
    unansweredChase_other: "When a contractor hasn't answered an invitation or quote request for {{count}} days, AssetWRX will notify {{who}}, and again each week until it's answered.",
    inspectionCompleted: "When an inspection is completed, AssetWRX will send its details to {{host}}.",
    inspectionUpdated: "When an inspection is updated{{status}}, AssetWRX will send its details to {{host}}.",
    jobCompleted: "When a job is completed, AssetWRX will send its details to {{host}}.",
    jobStatusChanged: "When a job changes status, AssetWRX will send its details to {{host}}.",
    assetCreated: "When an asset is created, AssetWRX will send its details to {{host}}.",
    assetDeleted: "When an asset is deleted, AssetWRX will send its details to {{host}}.",
    assetUpdated: "When an asset is updated, AssetWRX will send its details to {{host}}.",
    webhookTick_one: "Every {{count}} minute, AssetWRX will call {{host}}.",
    webhookTick_other: "Every {{count}} minutes, AssetWRX will call {{host}}.",
    inboundForward: "When this automation's inbound webhook receives JSON, AssetWRX will forward it to {{host}}.",
    inboundJobStatus: "When this automation's inbound webhook receives JSON, AssetWRX will update the named job's status from it.",
    inboundCreateJob: "When this automation's inbound webhook receives JSON, AssetWRX will create a job from it.",
    manualTest: "When you run it by hand, AssetWRX will send a test message to {{host}}.",
    fallback: "Automation",
  },
} as const;
